import ChangeCircleIcon from '@mui/icons-material/ChangeCircle'
import {Button, Chip, Fade, TextField, Tooltip} from '@mui/material'
import {envImagePath, hdmImageBackHost, serverLocalName} from 'GLOBAL/envVariables'
import {
  defaultImage,
  noImage,
  selectFailEFos,
  selectFailImg,
  selectSuccessEfos,
  selectSuccessImg,
  yMarker,
} from 'assets/imageDeclear'
import dayjs from 'dayjs'
import _ from 'lodash'
import ActivityMonitoringChart from 'pages/customer/charts/ActivityMonitoringChart'
import {LeakViewChart} from 'pages/customer/charts/LeakViewChart'
import {Map, MapMarker} from 'react-kakao-maps-sdk'
import {cancelAs, registerAs} from 'utils/apiCalling/api'

import {
  customerStatusHandler,
  globalFormatWithHyphens,
  globalSerialNumberFormatWithHyphens,
  ImageProcessStatusEnum,
} from 'utils/const/globalConst'
// import {globalFormatWithHyphens} from 'utils/const/globalConst'
import {isPhotoModalOffice} from 'utils/config/photoConfig'
import {
  imageRotateHandler,
  outerInstallShowHandler,
  showBusanInfoHandler,
  showTemperatureHandler,
} from 'utils/const/globalController'
import {handleCellClick} from 'utils/func/justUtils'
import {LeakViewChartBongHwa} from '../charts/LeakViewChartBongHwa'
import {TemperatureHistoryChart} from '../charts/TemperatureHistoryChart'
import {CustomTag} from '../simpleComponent/CustomTag'

export const customerActivityColumns = (filter: any) => {
  return [
    {
      field: 'customerNumber',
      headerName: '수용가 번호',
      width: 200,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <div className={'row text-center gap-3'}>
            <div>
              <span className={'text-hover-danger cursor-pointer text-primary fw-bold'}>
                {globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
              </span>
            </div>
            <div className={'d-flex gap-3 justify-content-center'}>
              <img
                alt={'suc-device'}
                src={
                  params?.row.deviceStatus ? selectSuccessImg(cooperIdx) : selectFailImg(cooperIdx)
                }
                style={{width: '50px'}}
              />

              <>
                <img
                  alt={'efos'}
                  src={
                    params?.row.efosStatus
                      ? selectSuccessEfos(cooperIdx)
                      : selectFailEFos(cooperIdx)
                  }
                  style={{width: '50px'}}
                />
              </>
            </div>
            <span>{params.row.cooperName}</span>
          </div>
        )
      },
    },
    {
      field: 'address',
      headerName: '주소',
      cellClassName: 'align-items-center',
      renderCell: (params: any) => {
        return (
          <div className={'row'}>
            <div className={'mb-2'}>이름 : {params.row.customerName}</div>
            <div className={'mb-2'}>주소 : {params.row.address}</div>
            <div className={'mb-2'}>담당자 : {params.row.managerName}</div>
            <div style={{height: '100px', width: '200px'}}>
              <Map // 지도를 표시할 Container
                center={{
                  // 지도의 중심좌표
                  lat: params.row?.latitude,
                  lng: params.row?.longitude,
                }}
                style={{
                  // 지도의 크기
                  width: '100%',
                  height: '90%',
                }}
                level={2} // 지도의 확대 레벨
                mapTypeId={kakao?.maps?.MapTypeId?.SKYVIEW}
                zoomable={false}
                draggable={false}
              >
                {/*<MapTypeControl position={kakao.maps.ControlPosition.TOPRIGHT} />*/}
                <MapMarker // 마커를 생성합니다
                  position={{
                    // 마커가 표시될 위치입니다
                    lat: params.row?.latitude,
                    lng: params.row?.longitude,
                  }}
                  image={{src: yMarker, size: {width: 30, height: 40}}}
                />
              </Map>
            </div>
          </div>
        )
      },
      width: 200,
      align: 'left',
      headerAlign: 'center',
    },
    {
      field: 'chart',
      headerName: '차트',
      renderCell: (params: any) => {
        return (
          <>
            {params.row.checkModelList?.length === 0 ? (
              <span className={'fw-bold'}>데이터가 존재하지 않습니다.</span>
            ) : (
              <ActivityMonitoringChart filter={filter} monitoringList={params.row.checkModelList} />
            )}
          </>
        )
      },
      width: 1200,
      // cellClassName: 'h-100 w-100',
      align: 'left',
      headerAlign: 'center',
    },
  ]
}

export const customerAllocationColumns = (setToInstallable: (row: any) => void) => {
  return [
    {
      field: 'officeName',
      headerName: '사업소',
      width: 170,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center'}>
            <span>{params.row.officeId}</span>
            <span>{params.row.officeName}</span>
          </div>
        )
      },
    },
    {
      field: 'customerNumber',
      headerName: '수용가 번호',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return <>{globalFormatWithHyphens(params?.row.officeId, params?.row.customerNumber)}</>
      },
    },
    {
      field: 'customerName',
      headerName: '이름',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'address',
      headerName: '주소',
      width: 500,
      align: 'left',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <div className={'row gap-1'}>
            <span>
              {params.row.addressRoad} / {params.row.addressDetail}
            </span>
            <span>
              {params.row.addressNumber} / {params.row.addressDetail}
            </span>
          </div>
        )
      },
    },
    {
      field: 'customerStatus',
      headerName: '설치 가능여부',
      width: 160,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <>
            {params.row.customerStatus === 'impossible' ? (
              <Button
                variant={'contained'}
                color={'success'}
                startIcon={<ChangeCircleIcon fontSize={'large'} />}
                onClick={async (e) => {
                  handleCellClick(e)
                  setToInstallable(params.row)
                }}
              >
                설치 가능변경
              </Button>
            ) : (
              <Chip label='설치가능' color={'primary'} sx={{fontSize: '15px'}} />
            )}
          </>
        )
      },
    },
    {
      field: 'allocationStatus',
      headerName: '할당내역',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center'}>
            <span>{params.row.assignStatus === true ? '할당' : '미할당'}</span>
          </div>
        )
      },
    },
    {
      field: 'assignFromName',
      headerName: '할당자',
      width: 200,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center'}>
            <span>{params.row.assignFromName === null ? '-' : params.row.assignFromName}</span>
          </div>
        )
      },
    },
    {
      field: 'assignToName',
      headerName: '설치자',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center'}>
            <span>{params.row.assignToName === null ? '-' : params.row.assignToName}</span>
          </div>
        )
      },
    },
  ]
}

export const customerInfoColumns = (
  imageDetailModalOpen: () => void,
  deviceDetailModalOpen: () => void,
  customerDetailModalOpen: () => void,
  setCustomerDetailData: any,
  setDeviceDetailData: any
) => {
  const chipValue = (value: string) => {
    switch (value) {
      case null:
        return '기계식'
      case 'analog':
        return '기계식'
      case 'digital':
        return '디지털'
      case 'gas':
        return '가스'
      case 'PRV':
        return '압력게이지'
      default:
        return '기계식'
    }
  }
  const chipColor = (value: string) => {
    switch (value) {
      case null:
      case 'analog':
        return 'bg-rose-600 text-white'
      case 'digital':
        return 'bg-amber-500 text-white'
      case 'gas':
        return 'bg-green-700 text-white'
      case 'PRV':
        return 'bg-indigo-700 text-white'
      default:
        return 'bg-red-500 text-white'
    }
  }
  return [
    {
      field: 'officeName',
      headerName: '사업소 명',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center'}>
            <span>{params.row.officeId}</span>
            <span>{params.row.officeName}</span>
          </div>
        )
      },
      width: 120,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'customerNumber',
      headerName: '수용가 번호',
      width: 180,
      align: 'center',
      headerAlign: 'center',

      renderCell: (params: any) => {
        return (
          <>
            <div
              onClick={(e) => {
                handleCellClick(e)
                setCustomerDetailData(params.row)
                customerDetailModalOpen()
              }}
              className={'row w-100 h-100 text-center '}
              style={{alignContent: 'center'}}
            >
              <span className={'text-hover-danger cursor-pointer text-primary fw-bold'}>
                {globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
              </span>
              <span className={'text-danger '}>
                {params.row.customerStatus === null
                  ? null
                  : params.row.customerStatus === 'as'
                  ? 'A/S'
                  : params.row.customerStatus === 'move'
                  ? '이전 철거'
                  : '철거'}
              </span>
            </div>
          </>
        )
      },
    },

    {
      field: 'customerInfo',
      headerName: '주소',
      renderCell: (params: any) => {
        return (
          <div className={'row'}>
            <span className={''}>{params.row.customerName}</span>
            <span>
              <strong style={{color: '#104f98'}}>도로명 </strong> : {params.row.addressRoad}{' '}
            </span>
            <span>
              <strong style={{color: '#f37005'}}>지번 </strong> : {params.row.addressNumber}{' '}
            </span>
            {params.row.addressDetail && (
              <span>
                <strong style={{color: 'rgba(86,31,13,0.7)'}}>상세주소 </strong> :{' '}
                {params.row.addressDetail}{' '}
              </span>
            )}
            {params.row.managerName !== 'NULL' && (
              <span>
                <strong style={{color: 'rgba(29,61,37,0.7)'}}>담당자 </strong> :{' '}
                {params.row.managerName}{' '}
              </span>
            )}
            <span>
              <strong style={{color: '#038109'}}>설치자 </strong> : {params.row.installerName}{' '}
            </span>
          </div>
        )
      },
      width: 350,
      align: 'left',
      headerAlign: 'center',
    },
    {
      field: 'deviceInfo',
      headerName: '배터리',
      renderCell: (params: any) => {
        const serialNumber = globalSerialNumberFormatWithHyphens(params.row.serialNumber)
        return (
          <div className={'row text-center'}>
            <span>{serialNumber}</span>
            <span className={`${params.row.batteryLevel < 30 ? 'text-danger' : 'text-dark'}`}>
              {params.row.batteryLevel}%
            </span>
          </div>
        )
      },
      width: 150,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'customerDetail',
      headerName: '온도',
      width: 100,
      align: 'center',
      headerAlign: 'center',

      renderCell: (params: any) => {
        const temp = params.row.temperature
        const meterDiameter = params?.row.meterDiameter

        return (
          <div className={'row text-center'}>
            <span>{meterDiameter ? `${meterDiameter} mm` : ''}</span>
            <span>{temp < 90 ? `${temp}°C` : '-'}</span>
          </div>
        )
      },
    },

    {
      field: 'efosStatus',
      headerName: '계량기 통신상태',
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <>
            <div
              className={'row w-100 h-100 text-center '}
              style={{alignContent: 'center'}}
              onClick={(e) => {
                handleCellClick(e)
                setDeviceDetailData(params.row)
                deviceDetailModalOpen()
              }}
            >
              <img
                src={
                  params?.row.efosStatus ? selectSuccessEfos(cooperIdx) : selectFailEFos(cooperIdx)
                }
                width={100}
                alt={'efos-check'}
              />
            </div>
          </>
        )
      },
      width: 160,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'deviceStatus',
      headerName: '단말기 통신상태',
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <div
            className={'row w-100 h-100 text-center '}
            style={{alignContent: 'center'}}
            onClick={(e) => {
              handleCellClick(e)
              setDeviceDetailData(params.row)
              deviceDetailModalOpen()
            }}
          >
            <img
              alt={'device-check'}
              src={
                params?.row.deviceStatus ? selectSuccessImg(cooperIdx) : selectFailImg(cooperIdx)
              }
              width={100}
            />
          </div>
        )
      },
      width: 160,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'image',
      headerName: '이미지',
      width: 350,
      align: 'center',

      headerAlign: 'center',
      renderCell: (params: any) => {
        const rotate: string = params.row.rotate
        return (
          <>
            {params.row.deviceType !== 'analog' ? (
              <div
                className={
                  'cursor-pointer text-gray-500 w-full flex justify-center h-full items-center'
                }
                onClick={(e) => {
                  setDeviceDetailData(params.row)
                  handleCellClick(e)
                  imageDetailModalOpen()
                }}
              >
                NO IMAGE
              </div>
            ) : (
              <div className={'row'}>
                <div
                  className={'d-flex gap-1 justify-content-end'}
                  style={{position: 'relative', top: '15px', zIndex: 888}}
                >
                  {params.row.rotate !== 0 && (
                    <Chip
                      label={`${params.row.rotate}° `}
                      color='primary'
                      sx={{fontSize: '17px'}}
                    />
                  )}

                  <CustomTag
                    label={chipValue(params.row.recognizedType)}
                    className={`text-[17px] h-[30px] ${chipColor(params.row.recognizedType)}`}
                  />
                </div>
                <img
                  alt={'device'}
                  className={'cursor-pointer'}
                  src={
                    params.row.filePath === null ? noImage : `${envImagePath}${params.row.filePath}`
                  }
                  style={{
                    transform: params.row.filePath
                      ? (Number(rotate) > 90 && Number(rotate) < 270) ||
                        (Number(rotate) < -90 && Number(rotate) > -270)
                        ? `rotate(${rotate}deg)`
                        : `rotate(0deg)`
                      : `rotate(0deg)`,
                  }}
                  width={320}
                  height={144}
                  onClick={(e) => {
                    setDeviceDetailData(params.row)
                    handleCellClick(e)
                    imageDetailModalOpen()
                  }}
                />
              </div>
            )}
          </>
        )
      },
    },

    {
      field: 'checkInfo',
      headerName: '검침일',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center'}>
            <div className={'d-flex justify-content-center'}>
              <span>
                {params.row.checkValue === '' ? (
                  <span className={'text-danger'}>인식불가</span>
                ) : (
                  params.row.checkValue
                )}
              </span>
              <span>
                {params.row.checkDecimalValue === '' || params.row.checkDecimalValue === null
                  ? ''
                  : '.' + params.row.checkDecimalValue?.split('.')[1]}
              </span>
            </div>
            <span>{dayjs(params.row.efosConnectAt).format('YYYY-MM-DD')}</span>
          </div>
        )
      },
      width: 170,
      align: 'center',
      headerAlign: 'center',
    },
  ]
}

export const customerInfoBoardVersionColumns = (
  imageDetailModalOpen: () => void,
  deviceDetailModalOpen: () => void,
  customerDetailModalOpen: () => void,
  setCustomerDetailData: any,
  setDeviceDetailData: any,
  userInfo: any,
  getcustomerInfo: () => void,
  cooperInfo: any,
  officeInfo: any,
  photoModalOpen: () => void,
  setPhotoData: any,
  setTargetRowId: any
) => {
  const chipValue = (value: string) => {
    switch (value) {
      case null:
        return '기계식'
      case 'analog':
        return '기계식'
      case 'digital':
        return '디지털'
      case 'gas':
        return '가스'
      case 'PRV':
        return '압력게이지'
      default:
        return '기계식'
    }
  }
  const chipColor = (value: string) => {
    switch (value) {
      case null:
      case 'analog':
        return 'bg-rose-600 text-white'
      case 'digital':
        return 'bg-amber-500 text-white'
      case 'gas':
        return 'bg-green-700 text-white'
      case 'PRV':
        return 'bg-indigo-700 text-white'
      default:
        return 'bg-red-500 text-white'
    }
  }
  return [
    {
      field: 'officeName',
      headerName: '사업소 명',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center text-truncate gap-2'}>
            <span className='text-truncate'>{params.row.officeId}</span>
            <span className='text-truncate'>{params.row.officeName}</span>
            <span className='text-truncate '>{params.row.cooperName}</span>
          </div>
        )
      },
      width: 120,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'customerNumber',
      headerName: 'A/S',
      width: 190,
      flex: 1,
      align: 'center',
      headerAlign: 'center',

      renderCell: (params: any) => {
        const {customerStatus, asInstallerName} = params.row
        return (
          <>
            <div
              className={'row w-100 h-100 text-center text-truncate'}
              style={{alignContent: 'center'}}
            >
              <span
                onClick={(e) => {
                  if (isPhotoModalOffice(officeInfo.value)) {
                    e.stopPropagation()
                    setTargetRowId(params.row.id)
                    setPhotoData(params.row)
                    photoModalOpen()
                  } else {
                    handleCellClick(e)
                    setCustomerDetailData(params.row)
                    customerDetailModalOpen()
                  }
                }}
                className={'text-hover-danger cursor-pointer text-primary fw-bold text-truncate'}
              >
                {globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
              </span>

              <span className='text-danger'>{customerStatusHandler(customerStatus)}</span>
              {asInstallerName && (
                <span className='text-black text-lg'>할당 : {asInstallerName}</span>
              )}

              <div className={'fw-normal mt-8'}>
                {(() => {
                  const {customerStatus} = params.row
                  if (customerStatus === null || customerStatus === 'remove') {
                    return (
                      <Button
                        variant='outlined'
                        color='error'
                        onClick={async (e) => {
                          handleCellClick(e)
                          registerAs(userInfo, [params.row], {promptCause: true, onDone: getcustomerInfo})
                        }}
                      >
                        A/S
                      </Button>
                    )
                  }
                  if (customerStatus === 'as') {
                    return (
                      <Button
                        variant='outlined'
                        color='error'
                        onClick={async (e) => {
                          handleCellClick(e)
                          cancelAs(userInfo, [params.row], {onDone: getcustomerInfo})
                        }}
                      >
                        A/S 취소
                      </Button>
                    )
                  }
                  return ''
                })()}
              </div>
            </div>
          </>
        )
      },
    },

    {
      field: 'customerInfo',
      headerName: '주소',
      renderCell: (params: any) => {
        return (
          <div className={'row text-truncate'}>
            <span className={'text-truncate'}>{params.row.customerName}</span>
            <span className='text-truncate'>
              <strong style={{color: '#104f98'}}>도로명 </strong> : {params.row.addressRoad}{' '}
            </span>
            <span className='text-truncate'>
              <strong style={{color: '#f37005'}}>지번 </strong> : {params.row.addressNumber}{' '}
            </span>
            {params.row.addressDetail && (
              <span className='text-truncate'>
                <strong style={{color: 'rgba(86,31,13,0.7)'}}>상세주소 </strong> :{' '}
                {params.row.addressDetail}{' '}
              </span>
            )}
            {params.row.managerName !== 'NULL' && (
              <span className='text-truncate'>
                <strong style={{color: 'rgba(29,61,37,0.7)'}}>담당자 </strong> :{' '}
                {params.row.managerName}{' '}
              </span>
            )}
            <span className='text-truncate'>
              <strong style={{color: '#038109'}}>설치자 </strong> : {params.row.installerName}{' '}
            </span>
          </div>
        )
      },
      width: 350,
      flex: 2,
      align: 'left',
      headerAlign: 'center',
    },
    {
      field: 'deviceInfo',
      headerName: '배터리',
      renderCell: (params: any) => {
        const serialNumber = globalSerialNumberFormatWithHyphens(params.row.serialNumber)
        const batteryLevel = params.row.batteryLevel
        const cooperIdx = cooperInfo.value
        return (
          <div className={'row text-center'}>
            <span>{serialNumber}</span>
            <span
              className={`${
                cooperIdx === 1 || cooperIdx === 0
                  ? batteryLevel < 30
                    ? 'text-danger'
                    : 'text-dark'
                  : 'text-dark'
              }`}
            >
              {cooperIdx === 1 || cooperIdx === 0 ? `${batteryLevel} %` : '-'}
            </span>
          </div>
        )
      },
      width: 150,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'customerDetail',
      headerName: '온도',
      width: 100,
      flex: 1,
      align: 'center',
      headerAlign: 'center',

      renderCell: (params: any) => {
        const temp = params.row.temperature
        return (
          <div className={'row text-center'}>
            <span>{params.row.meterDiameter} mm</span>
            <span>{temp < 90 ? `${temp}°C` : '-'}</span>
          </div>
        )
      },
    },

    {
      field: 'efosStatus',
      headerName: '계량기',
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <>
            <div
              className={'row w-100 h-100 text-center '}
              style={{alignContent: 'center'}}
              onClick={(e) => {
                handleCellClick(e)
                setDeviceDetailData(params.row)
                deviceDetailModalOpen()
              }}
            >
              <img
                src={
                  params?.row.efosStatus ? selectSuccessEfos(cooperIdx) : selectFailEFos(cooperIdx)
                }
                width={100}
                alt={'efos-check'}
              />
            </div>
          </>
        )
      },
      width: 120,

      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'deviceStatus',
      headerName: '단말기',
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx

        return (
          <>
            <div
              className={'row w-100 h-100 text-center '}
              style={{alignContent: 'center'}}
              onClick={(e) => {
                handleCellClick(e)
                setDeviceDetailData(params.row)
                deviceDetailModalOpen()
              }}
            >
              <img
                alt={'device-check'}
                src={
                  params.row.deviceStatus ? selectSuccessImg(cooperIdx) : selectFailImg(cooperIdx)
                }
                width={100}
              />
              {/* <span>{params.row.boardVersion === '22' ? 'v2.2' : 'v2.0'}</span> */}
            </div>
          </>
        )
      },
      width: 120,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'image',
      headerName: '이미지',
      width: 350,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const revisionHandler = (serverName: any) => {
          switch (serverName) {
            case 'suncheon':
            case 'dev':
              return true
            default:
              return false
          }
        }
        const originalImage =
          params.row.filePath === null ? noImage : `${envImagePath}${params.row.filePath}`
        const revisionImage =
          params.row.revisionPath === null
            ? ''
            : `${envImagePath}/device/imagerevision/${params.row.imei}/image`
        const rotate: string = params.row.rotate
        return (
          <>
            {params.row.deviceType !== 'analog' ? (
              <div
                className={
                  'cursor-pointer text-gray-500 w-full flex justify-center h-full items-center'
                }
                onClick={(e) => {
                  setDeviceDetailData(params.row)
                  handleCellClick(e)
                  imageDetailModalOpen()
                }}
              >
                NO IMAGE
              </div>
            ) : (
              <div className={'row'}>
                <div
                  className={'d-flex gap-1 justify-content-end'}
                  style={{position: 'relative', top: '15px', zIndex: 888}}
                >
                  {params.row.revisionPath && (
                    <Chip label={`보정`} color='secondary' sx={{fontSize: '17px'}} />
                  )}

                  {params.row.rotate !== 0 && (
                    <Chip
                      label={`${params.row.rotate}° `}
                      color='primary'
                      sx={{fontSize: '17px'}}
                    />
                  )}

                  <CustomTag
                    label={chipValue(params.row.recognizedType)}
                    className={`text-[17px] h-[30px] ${chipColor(params.row.recognizedType)}`}
                  />
                </div>
                <div
                  style={{
                    position: 'relative',
                    width: '320px',
                    height: '144px',
                  }}
                >
                  {/* Original Image */}
                  <img
                    alt={params.row.filePath ? 'Device Image' : 'No Image Available'}
                    className='cursor-pointer'
                    src={originalImage}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      transform:
                        params.row.filePath &&
                        ((Number(rotate) > 90 && Number(rotate) < 270) ||
                          (Number(rotate) < -90 && Number(rotate) > -270))
                          ? `rotate(${rotate}deg)`
                          : 'rotate(0deg)',
                    }}
                    onClick={(e) => {
                      setDeviceDetailData(params.row)
                      handleCellClick(e)
                      imageDetailModalOpen()
                    }}
                  />

                  {/* Revision Image */}
                  {revisionHandler(serverLocalName) && params.row.revisionPath !== null && (
                    <img
                      alt={params.row.filePath ? 'Device Image' : 'No Image Available'}
                      className='cursor-pointer'
                      src={revisionImage}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        opacity: 1,
                        pointerEvents: 'none',
                        transform:
                          params.row.filePath &&
                          ((Number(rotate) > 90 && Number(rotate) < 270) ||
                            (Number(rotate) < -90 && Number(rotate) > -270))
                            ? `rotate(${rotate}deg)`
                            : 'rotate(0deg)',
                      }}
                    />
                  )}
                </div>
              </div>
            )}
          </>
        )
      },
    },
    {
      field: 'checkInfo',
      headerName: '검침일',
      flex: 1,
      renderCell: (params: any) => {
        const status = params?.row?.processStatus
        const enumStatus = ImageProcessStatusEnum[status as keyof typeof ImageProcessStatusEnum]
        return (
          <div className={'row text-center'}>
            <div className={'d-flex justify-content-center'}>
              <span>
                {params.row.checkValue === '' ? (
                  <span className={'text-danger'}>인식불가</span>
                ) : (
                  params.row.checkValue
                )}
              </span>
              <span>
                {params.row.checkDecimalValue === '' || params.row.checkDecimalValue === null
                  ? ''
                  : '.' + params.row.checkDecimalValue?.split('.')[1]}
              </span>
            </div>

            <div className='my-2'>
              <span className={`${status !== 'COMPLETE' ? 'text-warning' : ''}`}>{enumStatus}</span>
            </div>

            <span>{dayjs(params.row.efosConnectAt).format('YYYY-MM-DD')}</span>
          </div>
        )
      },
      width: 160,
      align: 'center',
      headerAlign: 'center',
    },
  ]
}

export const customerInfoGyeryongBoardVersionColumns = (
  imageDetailModalOpen: () => void,
  deviceDetailModalOpen: () => void,
  customerDetailModalOpen: () => void,
  setCustomerDetailData: any,
  setDeviceDetailData: any,
  userInfo: any,
  getcustomerInfo: () => void,
  cooperInfo: any,
  officeInfo: any,
  photoModalOpen: () => void,
  setPhotoData: any,
  setTargetRowId: any
) => {
  const chipValue = (value: string) => {
    switch (value) {
      case null:
        return '기계식'
      case 'analog':
        return '기계식'
      case 'digital':
        return '디지털'
      case 'gas':
        return '가스'
      case 'PRV':
        return '압력게이지'
      default:
        return '기계식'
    }
  }
  const chipColor = (value: string) => {
    switch (value) {
      case null:
      case 'analog':
        return 'bg-rose-600 text-white'
      case 'digital':
        return 'bg-amber-500 text-white'
      case 'gas':
        return 'bg-green-700 text-white'
      case 'PRV':
        return 'bg-indigo-700 text-white'
      default:
        return 'bg-red-500 text-white'
    }
  }
  return [
    {
      field: 'officeName',
      headerName: '사업소 명',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center text-truncate gap-2'}>
            <span className='text-truncate'>{params.row.officeId}</span>
            <span className='text-truncate'>{params.row.officeName}</span>
            <span className='text-truncate '>{params.row.cooperName}</span>
          </div>
        )
      },
      width: 120,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'customerNumber',
      headerName: 'A/S',
      width: 190,
      flex: 1,
      align: 'center',
      headerAlign: 'center',

      renderCell: (params: any) => {
        const {customerStatus, asInstallerName, customerNumbmer} = params.row
        return (
          <>
            <div
              className={'row w-100 h-100 text-center text-truncate'}
              style={{alignContent: 'center'}}
            >
              <span
                onClick={(e) => {
                  if (isPhotoModalOffice(officeInfo.value)) {
                    e.stopPropagation()
                    setTargetRowId(params.row.id)
                    setPhotoData(params.row)
                    photoModalOpen()
                  } else {
                    handleCellClick(e)
                    setCustomerDetailData(params.row)
                    customerDetailModalOpen()
                  }
                }}
                className={'text-hover-danger cursor-pointer text-primary fw-bold text-truncate'}
              >
                {globalFormatWithHyphens(params?.row?.officeId, params?.row?.customerNumber)}
              </span>

              <span className='text-danger'>{customerStatusHandler(customerStatus)}</span>
              {asInstallerName && (
                <span className='text-black text-lg'>할당 : {asInstallerName}</span>
              )}

              <div className={'fw-normal mt-8'}>
                {(() => {
                  const {customerStatus} = params.row
                  if (customerStatus === null || customerStatus === 'remove') {
                    return (
                      <Button
                        variant='outlined'
                        color='error'
                        onClick={async (e) => {
                          handleCellClick(e)
                          registerAs(userInfo, [params.row], {promptCause: true, onDone: getcustomerInfo})
                        }}
                      >
                        A/S
                      </Button>
                    )
                  }
                  if (customerStatus === 'as') {
                    return (
                      <Button
                        variant='outlined'
                        color='error'
                        onClick={async (e) => {
                          handleCellClick(e)
                          cancelAs(userInfo, [params.row], {onDone: getcustomerInfo})
                        }}
                      >
                        A/S 취소
                      </Button>
                    )
                  }
                  return ''
                })()}
              </div>
            </div>
          </>
        )
      },
    },

    {
      field: 'customerInfo',
      headerName: '주소',
      renderCell: (params: any) => {
        return (
          <div className={'row text-truncate'}>
            <span className={'text-truncate'}>{params.row.customerName}</span>
            <span className='text-truncate'>
              <strong style={{color: '#104f98'}}>도로명 </strong> : {params.row.addressRoad}
            </span>
            <span className='text-truncate'>
              <strong style={{color: '#f37005'}}>지번 </strong> : {params.row.addressNumber}
            </span>
            {params.row.addressDetail && (
              <span className='text-truncate'>
                <strong style={{color: 'rgba(86,31,13,0.7)'}}>상세주소 </strong> :{' '}
                {params.row.addressDetail}
              </span>
            )}
            {params.row.managerName !== 'NULL' && (
              <span className='text-truncate'>
                <strong style={{color: 'rgba(29,61,37,0.7)'}}>담당자 </strong> :{' '}
                {params.row.managerName}
              </span>
            )}
            <span className='text-truncate'>
              <strong style={{color: '#038109'}}>설치자 </strong> : {params.row.installerName}
            </span>
          </div>
        )
      },
      width: 350,
      flex: 2,
      align: 'left',
      headerAlign: 'center',
    },
    {
      field: 'deviceInfo',
      headerName: '배터리',
      renderCell: (params: any) => {
        const serialNumber = globalSerialNumberFormatWithHyphens(params.row.serialNumber)
        const externalSerialNumber = params.row.externalSerialNumber
        const batteryLevel = params.row.batteryLevel
        const cooperIdx = cooperInfo.value
        return (
          <div className={'row text-center'}>
            <span>{serialNumber}</span>
            {!showBusanInfoHandler(serverLocalName, officeInfo.value) && (
              <span className='text-blue-400'>{externalSerialNumber}</span>
            )}
            <span
              className={`${
                cooperIdx === 1 || cooperIdx === 0
                  ? batteryLevel < 30
                    ? 'text-danger'
                    : 'text-dark'
                  : 'text-dark'
              }`}
            >
              {cooperIdx === 1 || cooperIdx === 0 ? `${batteryLevel} %` : '-'}
            </span>
          </div>
        )
      },
      width: 150,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'customerDetail',
      headerName: '온도',
      width: 100,
      flex: 1,
      align: 'center',
      headerAlign: 'center',

      renderCell: (params: any) => {
        const temp = params?.row.temperature
        const meterDiameter = params?.row.meterDiameter
        return (
          <div className={'row text-center'}>
            <span>{meterDiameter ? `${meterDiameter} mm` : ''}</span>
            <span>{temp < 90 ? `${temp}°C` : '-'}</span>
          </div>
        )
      },
    },
    ...(outerInstallShowHandler(serverLocalName, officeInfo.value)
      ? [
          {
            field: 'extraInfo',
            headerName: '외함',
            width: 180,
            align: 'left',
            headerAlign: 'center',
            renderCell: (params: any) => {
              const outerCaseInstalled = params?.row.isOuterCaseInstalled === true
              const outerCaseSize =
                params?.row.outerCaseSizeType === '소'
                  ? '小'
                  : params?.row.outerCaseSizeType === '대'
                  ? '大'
                  : ''
              const externalDisplayInstalled = params?.row.isExternalDisplayInstalled === true

              return (
                <div className='flex flex-col text-xl text-gray-800 leading-8 font-semibold'>
                  {externalDisplayInstalled && (
                    <div className='flex items-center gap-2'>
                      <div className='w-[7.5rem] tracking-wider'>외부표시장치</div>

                      <Chip label='설치' size='small' color='primary' className='px-1' />
                    </div>
                  )}
                  {outerCaseInstalled && (
                    <div className='flex items-center gap-2'>
                      <div className='w-[7.5rem] flex justify-between'>
                        <span>외</span>
                        <span>함{outerCaseSize ? `(${outerCaseSize})` : ''}</span>
                      </div>
                      <Chip label='설치' size='small' color='primary' className='px-1' />
                    </div>
                  )}
                </div>
              )
            },
          },
        ]
      : []),

    {
      field: 'efosStatus',
      headerName: '계량기',
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <>
            <div
              className={'row w-100 h-100 text-center '}
              style={{alignContent: 'center'}}
              onClick={(e) => {
                handleCellClick(e)
                setDeviceDetailData(params.row)
                deviceDetailModalOpen()
              }}
            >
              <img
                src={
                  params?.row.efosStatus ? selectSuccessEfos(cooperIdx) : selectFailEFos(cooperIdx)
                }
                width={100}
                alt={'efos-check'}
              />
            </div>
          </>
        )
      },
      width: 120,
      resizable: false,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'deviceStatus',
      headerName: '단말기',
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx

        return (
          <>
            <div
              className={'row w-100 h-100 text-center '}
              style={{alignContent: 'center'}}
              onClick={(e) => {
                handleCellClick(e)
                setDeviceDetailData(params.row)
                deviceDetailModalOpen()
              }}
            >
              <img
                alt={'device-check'}
                src={
                  params.row.deviceStatus ? selectSuccessImg(cooperIdx) : selectFailImg(cooperIdx)
                }
                width={100}
              />
            </div>
          </>
        )
      },
      resizable: false,
      width: 120,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'image',
      headerName: '이미지',
      width: 350,
      minWidth: 350,
      maxWidth: 350,
      resizable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const originalImage =
          params.row.filePath === null ? noImage : `${envImagePath}${params.row.filePath}`
        const rotate: string = params.row.rotate

        return (
          <>
            {params.row.deviceType !== 'analog' ? (
              <div
                className='cursor-pointer text-gray-500 w-full flex justify-center h-full items-center'
                onClick={(e) => {
                  setDeviceDetailData(params.row)
                  handleCellClick(e)
                  imageDetailModalOpen()
                }}
              >
                NO IMAGE
              </div>
            ) : (
              <div className='row '>
                {/* 태그 영역 */}
                <div
                  className='d-flex gap-1 justify-content-end'
                  style={{position: 'relative', top: '10px', zIndex: 888}}
                >
                  {isPhotoModalOffice(officeInfo.value) &&
                    params.row.existsInstallPhoto && (
                      <CustomTag label='사진첩' className='text-[17px] text-white bg-slate-600' />
                    )}

                  {params.row.revisionPath && (
                    <Chip label='보정' color='secondary' sx={{fontSize: '17px'}} />
                  )}

                  {params.row.rotate !== 0 && (
                    <CustomTag
                      label={`${params.row.rotate}° `}
                      className='text-[17px] h-[30px] bg-blue-500 text-white'
                    />
                  )}

                  <CustomTag
                    label={chipValue(params.row.recognizedType)}
                    className={`text-[17px] h-[30px] ${chipColor(params.row.recognizedType)}`}
                  />
                </div>

                {/* 이미지 영역 */}
                <div
                  style={{
                    overflow: 'hidden',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    width: '100%',
                  }}
                >
                  <img
                    alt='check-device'
                    src={originalImage}
                    className='cursor-pointer transition-transform duration-300'
                    style={{
                      transform: `${
                        params.row.filePath &&
                        ((Number(rotate) > 90 && Number(rotate) < 270) ||
                          (Number(rotate) < -90 && Number(rotate) > -270))
                          ? `rotate(180deg)`
                          : 'rotate(0deg)'
                      }`,
                      width: 'auto',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                    onClick={(e) => {
                      handleCellClick(e)
                      imageDetailModalOpen()
                      setDeviceDetailData(params.row)
                    }}
                  />
                </div>
              </div>
            )}
          </>
        )
      },
    },

    {
      field: 'checkInfo',
      headerName: '검침일',
      flex: 1,
      renderCell: (params: any) => {
        const status = params?.row?.processStatus
        const enumStatus = ImageProcessStatusEnum[status as keyof typeof ImageProcessStatusEnum]
        const isBlank = params.row.processStatus === 'NONE' && params.row.recognizedType === 'PRV'
        return (
          <div className={'row text-center'}>
            <div className={'d-flex justify-content-center'}>
              <span>
                {isBlank ? (
                  '-'
                ) : params.row.checkValue === '' || params.row.checkValue === null ? (
                  <span className={'text-danger'}>인식불가</span>
                ) : (
                  params.row.checkValue
                )}
              </span>
              <span>
                {params.row.checkDecimalValue === '' || params.row.checkDecimalValue === null
                  ? ''
                  : '.' + params.row.checkDecimalValue?.split('.')[1]}
              </span>
            </div>

            <div className='my-2'>
              <span className={`${status !== 'COMPLETE' ? 'text-warning' : ''}`}>{enumStatus}</span>
            </div>

            <span>{dayjs(params.row.efosConnectAt).format('YYYY-MM-DD')}</span>
          </div>
        )
      },
      width: 160,
      align: 'center',
      headerAlign: 'center',
    },
  ]
}

export const customerInfoCorrectColumns = (
  cooperInfo: any,
  connectStatus: any,
  state: any,
  type?: any,
  newCustomerNumber?: any
) => {
  if (connectStatus === 'true' || state !== 'result') {
    return [
      {
        field: 'officeName',
        headerName: '사업소 명',
        renderCell: (params: any) => {
          return (
            <div className={'row text-center text-truncate gap-2'}>
              <span className='text-truncate'>{params.row.officeId}</span>
              <span className='text-truncate'>{params.row.officeName}</span>
              <span className='text-truncate '>{params.row.cooperName}</span>
            </div>
          )
        },
        width: 120,
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
      },
      {
        field: 'customerNumber',
        headerName: '수용가번호',
        width: 190,
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,

        renderCell: (params: any) => {
          const {customerStatus} = params.row
          return (
            <>
              <div
                className={'row w-100 h-100 text-center text-truncate'}
                style={{alignContent: 'center'}}
              >
                <span
                  className={'text-hover-danger cursor-pointer text-primary fw-bold text-truncate'}
                >
                  {type === 'customer' && state === 'result'
                    ? globalFormatWithHyphens(params.row.officeId, newCustomerNumber)
                    : globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
                </span>
                <span className={'text-danger '}>{customerStatusHandler(customerStatus)}</span>
              </div>
            </>
          )
        },
      },

      {
        field: 'customerInfo',
        headerName: '이름 / 주소',
        sortable: false,
        renderCell: (params: any) => {
          return (
            <div className={'row text-truncate'}>
              <span className={'text-truncate'}>{params.row.customerName}</span>
              <span className='text-truncate'>
                <strong style={{color: '#104f98'}}>도로명 </strong> : {params.row.addressRoad}{' '}
              </span>
              <span className='text-truncate'>
                <strong style={{color: '#f37005'}}>지번 </strong> : {params.row.addressNumber}{' '}
              </span>
              {params.row.addressDetail && (
                <span className='text-truncate'>
                  <strong style={{color: 'rgba(86,31,13,0.7)'}}>상세주소 </strong> :{' '}
                  {params.row.addressDetail}{' '}
                </span>
              )}
            </div>
          )
        },
        width: 350,
        flex: 2,
        align: 'left',
        headerAlign: 'center',
      },
      {
        field: 'deviceInfo',
        headerName: 'S/N',
        sortable: false,
        renderCell: (params: any) => {
          const serialNumber = globalSerialNumberFormatWithHyphens(params.row.serialNumber)
          const batteryLevel = params.row.batteryLevel
          const cooperIdx = cooperInfo.value
          return (
            <div className={'row text-center'}>
              <span>{serialNumber}</span>
              <span
                className={`${
                  cooperIdx === 1 ? (batteryLevel < 30 ? 'text-danger' : 'text-dark') : 'text-dark'
                }`}
              >
                {cooperIdx === 1 ? `${batteryLevel} %` : '-'}
              </span>
            </div>
          )
        },
        width: 150,
        flex: 1,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'customerDetail',
        headerName: '구경',
        width: 100,
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,

        renderCell: (params: any) => {
          const temp = params.row.temperature
          return (
            <div className={'row text-center'}>
              <span>{params.row.meterDiameter} mm</span>
              <span>{temp < 90 ? `${temp}°C` : '-'}</span>
            </div>
          )
        },
      },

      {
        field: 'image',
        headerName: '이미지',
        width: 350,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        renderCell: (params: any) => {
          const revisionHandler = (serverName: any) => {
            switch (serverName) {
              case 'suncheon':
              case 'dev':
                return true
              default:
                return false
            }
          }
          const originalImage =
            params.row.filePath === null ? noImage : `${envImagePath}${params.row.filePath}`
          const revisionImage =
            params.row.revisionPath === null
              ? ''
              : `${envImagePath}/device/imagerevision/${params.row.imei}/image`
          const rotate: string = params.row.rotate
          return (
            <>
              {params.row.deviceType !== 'analog' ? (
                <img className={'cursor-pointer'} src={defaultImage} alt={'default'} />
              ) : (
                <div className={'row'}>
                  <div
                    style={{
                      position: 'relative',
                    }}
                  >
                    {/* Original Image */}
                    <img
                      alt={params.row.filePath ? 'Device Image' : 'No Image Available'}
                      className='cursor-pointer'
                      src={originalImage}
                      style={{
                        transform: params.row.filePath
                          ? (Number(rotate) > 90 && Number(rotate) < 270) ||
                            (Number(rotate) < -90 && Number(rotate) > -270)
                            ? `rotate(${rotate}deg)`
                            : `rotate(0deg)`
                          : `rotate(0deg)`,
                      }}
                    />

                    {/* Revision Image */}
                    {revisionHandler(serverLocalName) && params.row.revisionPath !== null && (
                      <img
                        alt={params.row.filePath ? 'Device Image' : 'No Image Available'}
                        className='cursor-pointer'
                        src={revisionImage}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          opacity: 1,
                          pointerEvents: 'none',
                          transform:
                            params.row.filePath &&
                            ((Number(rotate) > 90 && Number(rotate) < 270) ||
                              (Number(rotate) < -90 && Number(rotate) > -270))
                              ? `rotate(${rotate}deg)`
                              : 'rotate(0deg)',
                        }}
                      />
                    )}
                  </div>
                </div>
              )}
            </>
          )
        },
      },

      {
        field: 'checkInfo',
        headerName: '검침일',
        sortable: false,
        flex: 1,
        renderCell: (params: any) => {
          const status = params?.row?.processStatus
          const enumStatus = ImageProcessStatusEnum[status as keyof typeof ImageProcessStatusEnum]
          return (
            <div className={'row text-center'}>
              <div className={'d-flex justify-content-center'}>
                <span>
                  {params.row.checkValue === '' ? (
                    <span className={'text-danger'}>인식불가</span>
                  ) : (
                    params.row.checkValue
                  )}
                </span>
                <span>
                  {params.row.checkDecimalValue === '' || params.row.checkDecimalValue === null
                    ? ''
                    : '.' + params.row.checkDecimalValue?.split('.')[1]}
                </span>
              </div>

              <div className='my-2'>
                <span className={`${status !== 'COMPLETE' ? 'text-warning' : ''}`}>
                  {enumStatus}
                </span>
              </div>

              <span>{dayjs(params.row.efosConnectAt).format('YYYY-MM-DD')}</span>
            </div>
          )
        },
        width: 160,
        align: 'center',
        headerAlign: 'center',
      },
    ]
  } else {
    return []
  }
}

export const customerBinaryCheckColumns = (
  customerDetailModalOpen: () => void,
  setCustomerDetailData: any,
  userInfo: any,
  getcustomerInfo: () => void,
  officeInfo: any,
  photoModalOpen: () => void,
  setPhotoData: any,
  setTargetRowId: any,
  setSelectedRow: any,
  setIsZoomOpen: any
) => {
  const binaryCheckLabel = (start: any, end: any) => {
    if (start === end && start !== null && end !== null) {
      return '같은 이미지'
    } else {
      return '다른 이미지'
    }
  }

  const binaryCheckColor = (start: any, end: any) => {
    if (start === end && start !== null && end !== null) {
      return 'bg-amber-500 text-white'
    } else {
      return 'bg-slate-700 text-white'
    }
  }

  return [
    {
      field: 'officeName',
      headerName: '사업소 명',
      width: 120,
      flex: 120,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        return (
          <div className={'row text-center text-truncate gap-2 text-lg'}>
            <span className='text-truncate'>{params.row.officeId}</span>
            <span className='text-truncate'>{params.row.officeName}</span>
            <span className='text-truncate'>{params.row.cooperName}</span>
          </div>
        )
      },
    },
    {
      field: 'customerNumber',
      headerName: 'A/S',
      width: 190,
      flex: 190,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const {customerStatus, asInstallerName} = params.row
        return (
          <>
            <div
              className={'row w-100 h-100 text-center text-truncate'}
              style={{alignContent: 'center'}}
            >
              <span
                onClick={(e) => {
                  if (isPhotoModalOffice(officeInfo.value)) {
                    e.stopPropagation()
                    setTargetRowId(params.row.id)
                    setPhotoData(params.row)
                    photoModalOpen()
                  } else {
                    handleCellClick(e)
                    setCustomerDetailData(params.row)
                    customerDetailModalOpen()
                  }
                }}
                className={'text-hover-danger cursor-pointer text-primary fw-bold text-truncate'}
              >
                {globalFormatWithHyphens(params?.row?.officeId, params?.row?.customerNumber)}
              </span>

              <span className='text-danger'>{customerStatusHandler(customerStatus)}</span>
              {asInstallerName && (
                <span className='text-black text-lg'>할당 : {asInstallerName}</span>
              )}

              <div className={'fw-normal mt-8'}>
                {(() => {
                  const {customerStatus} = params.row
                  if (customerStatus === null || customerStatus === 'remove') {
                    return (
                      <Button
                        variant='outlined'
                        color='error'
                        onClick={async (e) => {
                          handleCellClick(e)
                          registerAs(userInfo, [params.row], {promptCause: true, onDone: getcustomerInfo})
                        }}
                      >
                        A/S
                      </Button>
                    )
                  }
                  if (customerStatus === 'as') {
                    return (
                      <Button
                        variant='outlined'
                        color='error'
                        onClick={async (e) => {
                          handleCellClick(e)
                          cancelAs(userInfo, [params.row], {onDone: getcustomerInfo})
                        }}
                      >
                        A/S 취소
                      </Button>
                    )
                  }
                  return ''
                })()}
              </div>
            </div>
          </>
        )
      },
    },
    {
      field: 'customerInfo',
      headerName: '주소',
      width: 280,
      flex: 280,
      align: 'left',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        return (
          <div className={'row text-truncate text-xl'}>
            <span className={'text-truncate'}>{params.row.customerName}</span>
            <span className='text-truncate'>
              <strong style={{color: '#104f98'}}>도로명 </strong> : {params.row.addressRoad}
            </span>
            <span className='text-truncate'>
              <strong style={{color: '#f37005'}}>지번 </strong> : {params.row.addressNumber}
            </span>
            {params.row.addressDetail && (
              <span className='text-truncate'>
                <strong style={{color: 'rgba(86,31,13,0.7)'}}>상세주소 </strong> :{' '}
                {params.row.addressDetail}
              </span>
            )}
            {params.row.managerName !== 'NULL' && (
              <span className='text-truncate'>
                <strong style={{color: 'rgba(29,61,37,0.7)'}}>담당자 </strong> :{' '}
                {params.row.managerName}
              </span>
            )}
            <span className='text-truncate'>
              <strong style={{color: '#038109'}}>설치자 </strong> : {params.row.installerName}
            </span>
          </div>
        )
      },
    },
    {
      field: 'efosStatus',
      headerName: '계량기',
      width: 110,
      flex: 110,
      resizable: false,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <>
            <div
              className='row w-100 h-100 text-center flex items-center justify-center'
              onClick={(e) => {
                handleCellClick(e)
              }}
            >
              <img
                className='max-w-[100px]'
                src={
                  params?.row.efosStatus ? selectSuccessEfos(cooperIdx) : selectFailEFos(cooperIdx)
                }
                alt={'efos-check'}
              />
            </div>
          </>
        )
      },
    },
    {
      field: 'deviceStatus',
      headerName: '단말기',
      resizable: false,
      width: 110,
      flex: 110,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <>
            <div
              className='row w-100 h-100 text-center flex items-center justify-center'
              onClick={(e) => {
                handleCellClick(e)
              }}
            >
              <img
                className='max-w-[100px]'
                alt={'device-check'}
                src={
                  params.row.deviceStatus ? selectSuccessImg(cooperIdx) : selectFailImg(cooperIdx)
                }
              />
            </div>
          </>
        )
      },
    },
    {
      field: 'firstImage',
      headerName: '시작 날짜 이미지',
      width: 350,
      minWidth: 350,
      maxWidth: 350,
      flex: 350,
      resizable: false,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const originalImage =
          params.row.sfilePath === null ? noImage : `${envImagePath}${params.row.sfilePath}`
        const rotate: string = params.row.rotate
        const rows = params.row
        return (
          <>
            {params.row.deviceType !== 'analog' ? (
              <div
                className='cursor-pointer text-gray-500 w-full flex justify-center h-full items-center'
                onClick={(e) => {
                  handleCellClick(e)
                }}
              >
                NO IMAGE
              </div>
            ) : (
              <div className='row '>
                <div
                  style={{
                    overflow: 'hidden',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    width: '100%',
                  }}
                >
                  <img
                    alt='check-device'
                    src={originalImage}
                    className='cursor-pointer transition-transform duration-300'
                    style={{
                      transform: `${
                        params.row.sfilePath &&
                        ((Number(rotate) > 90 && Number(rotate) < 270) ||
                          (Number(rotate) < -90 && Number(rotate) > -270))
                          ? `rotate(180deg)`
                          : 'rotate(0deg)'
                      }`,
                      width: 'auto',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                    onClick={(e) => {
                      setIsZoomOpen(true)
                      setSelectedRow(rows)
                      handleCellClick(e)
                    }}
                  />
                </div>
              </div>
            )}
          </>
        )
      },
    },
    {
      field: 'endImage',
      headerName: '마지막 날짜 이미지',
      width: 350,
      minWidth: 350,
      maxWidth: 350,
      flex: 350,
      resizable: false,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const originalImage =
          params.row.efilePath === null ? noImage : `${envImagePath}${params.row.efilePath}`
        const rotate: string = params.row.rotate
        const rows = params.row
        return (
          <>
            {params.row.deviceType !== 'analog' ? (
              <div
                className='cursor-pointer text-gray-500 w-full flex justify-center h-full items-center'
                onClick={(e) => {
                  handleCellClick(e)
                }}
              >
                NO IMAGE
              </div>
            ) : (
              <div className='row'>
                <div
                  style={{
                    overflow: 'hidden',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    width: '100%',
                  }}
                >
                  <img
                    alt='check-device'
                    src={originalImage}
                    className='cursor-pointer transition-transform duration-300'
                    style={{
                      transform: `${
                        params.row.efilePath &&
                        ((Number(rotate) > 90 && Number(rotate) < 270) ||
                          (Number(rotate) < -90 && Number(rotate) > -270))
                          ? `rotate(180deg)`
                          : 'rotate(0deg)'
                      }`,
                      width: 'auto',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                    onClick={(e) => {
                      setIsZoomOpen(true)
                      setSelectedRow(rows)
                      handleCellClick(e)
                    }}
                  />
                </div>
              </div>
            )}
          </>
        )
      },
    },
    {
      field: 'tag',
      headerName: '이미지 검증 결과',
      width: 150,
      flex: 150,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const {simageHash, eimageHash} = params?.row
        return (
          <div className={'flex flex-col text-center gap-4'}>
            <div>
              <CustomTag
                label={`${binaryCheckLabel(simageHash, eimageHash)}`}
                className={`${binaryCheckColor(simageHash, eimageHash)}`}
              />
            </div>
          </div>
        )
      },
    },
  ]
}

// CustomerIssueType 전체 9종 - 각 타입별 고유 색상
export const flaggedReviewStatusOptions = [
  {
    key: 'SAME_IMAGE_HASH',
    label: '동일 이미지',
    dotClassName: 'bg-violet-500',
    badgeClassName: 'bg-violet-100 text-violet-700 border border-violet-300',
    chartColor: '#8b5cf6',
  },
  {
    key: 'METER_VALUE_DANGER',
    label: '비정상 사용량',
    dotClassName: 'bg-orange-600',
    badgeClassName: 'bg-orange-100 text-orange-800 border border-orange-400',
    chartColor: '#ea580c',
  },
  {
    key: 'METER_VALUE_WARNING',
    label: '검침값 확인 필요',
    dotClassName: 'bg-cyan-500',
    badgeClassName: 'bg-cyan-100 text-cyan-700 border border-cyan-300',
    chartColor: '#06b6d4',
  },
  {
    key: 'METER_VALUE_RECOGNITION_FAIL',
    label: '인식 실패',
    dotClassName: 'bg-red-500',
    badgeClassName: 'bg-red-100 text-red-700 border border-red-300',
    chartColor: '#ef4444',
  },
  {
    key: 'METER_VALUE_DIGIT_ERROR',
    label: '자릿수 오류',
    dotClassName: 'bg-yellow-500',
    badgeClassName: 'bg-yellow-100 text-yellow-700 border border-yellow-300',
    chartColor: '#eab308',
  },
  {
    key: 'IMAGE_ERROR',
    label: '이미지 에러',
    dotClassName: 'bg-slate-500',
    badgeClassName: 'bg-slate-100 text-slate-700 border border-slate-300',
    chartColor: '#64748b',
  },
  {
    key: 'BATTERY_CHECK',
    label: '베터리 확인 필요',
    dotClassName: 'bg-lime-500',
    badgeClassName: 'bg-lime-100 text-lime-700 border border-lime-300',
    chartColor: '#84cc16',
  },
  {
    key: 'DEVICE_COMMUNICATION_FAIL',
    label: '단말기 통신 불량',
    dotClassName: 'bg-sky-500',
    badgeClassName: 'bg-sky-100 text-sky-700 border border-sky-300',
    chartColor: '#0ea5e9',
  },
  {
    key: 'METER_COMMUNICATION_FAIL',
    label: '검침기 통신 불량',
    dotClassName: 'bg-indigo-500',
    badgeClassName: 'bg-indigo-100 text-indigo-700 border border-indigo-300',
    chartColor: '#6366f1',
  },
]

/**
 * 상세 모달(/customer-issue/checkmeters) 전용 이슈 옵션.
 * 상세는 이미지의 processStatus / sameImageHash 기준으로만 이슈가 산출되므로
 * 배터리/단말기 통신/검침기 통신 불량은 이미지 리스트에서 확인 불가 → 제외.
 */
const flaggedReviewImageIssueKeys = [
  'SAME_IMAGE_HASH',
  'METER_VALUE_DANGER',
  'METER_VALUE_WARNING',
  'METER_VALUE_RECOGNITION_FAIL',
  'METER_VALUE_DIGIT_ERROR',
  'IMAGE_ERROR',
]

export const flaggedReviewImageStatusOptions = flaggedReviewStatusOptions.filter((option) =>
  flaggedReviewImageIssueKeys.includes(option.key)
)

export const customerFlaggedReviewColumns = (
  customerDetailModalOpen: () => void,
  setCustomerDetailData: any,
  userInfo: any,
  getcustomerInfo: () => void,
  officeInfo: any,
  photoModalOpen: () => void,
  setPhotoData: any,
  setTargetRowId: any,
  setSelectedRow: any,
  setIsZoomOpen: any,
  imageDetailModalOpen: () => void,
  setDeviceDetailData: any,
  // A/S 액션은 react-query mutation 훅에서 주입 (기존 requestAsNew/requestAsCancelNew 대체)
  onRequestAs?: (row: any) => void,
  onCancelAs?: (row: any) => void,
  asPending?: boolean
) => {
  const chipValue = (value: string) => {
    switch (value) {
      case null:
        return '기계식'
      case 'analog':
        return '기계식'
      case 'digital':
        return '디지털'
      case 'gas':
        return '가스'
      case 'PRV':
        return '압력게이지'
      default:
        return '기계식'
    }
  }
  const chipColor = (value: string) => {
    switch (value) {
      case null:
      case 'analog':
        return 'bg-rose-600 text-white'
      case 'digital':
        return 'bg-amber-500 text-white'
      case 'gas':
        return 'bg-green-700 text-white'
      case 'PRV':
        return 'bg-indigo-700 text-white'
      default:
        return 'bg-red-500 text-white'
    }
  }

  const recentImageColumn = {
    field: 'image',
    headerName: '이미지',
    width: 350,
    minWidth: 350,
    maxWidth: 350,
    resizable: false,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params: any) => {
      const originalImage =
        params.row.filePath === null ? noImage : `${envImagePath}${params.row.filePath}`
      const rotate: string = params.row.rotate

      return (
        <>
          {params.row.deviceType !== 'analog' ? (
            <div
              className='cursor-pointer text-gray-500 w-full flex justify-center h-full items-center'
              onClick={(e) => {
                setDeviceDetailData(params.row)
                handleCellClick(e)
                imageDetailModalOpen()
              }}
            >
              NO IMAGE
            </div>
          ) : (
            <div className='row '>
              {/* 태그 영역 */}
              <div
                className='d-flex gap-1 justify-content-end'
                style={{position: 'relative', top: '10px', zIndex: 888}}
              >
                {isPhotoModalOffice(officeInfo.value) &&
                  params.row.existsInstallPhoto && (
                    <CustomTag label='사진첩' className='text-[17px] text-white bg-slate-600' />
                  )}

                {params.row.revisionPath && (
                  <Chip label='보정' color='secondary' sx={{fontSize: '17px'}} />
                )}

                {params.row.rotate !== 0 && (
                  <CustomTag
                    label={`${params.row.rotate}° `}
                    className='text-[17px] h-[30px] bg-blue-500 text-white'
                  />
                )}

                <CustomTag
                  label={chipValue(params.row.recognizedType)}
                  className={`text-[17px] h-[30px] ${chipColor(params.row.recognizedType)}`}
                />
              </div>

              {/* 이미지 영역 */}
              <div
                style={{
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  width: '100%',
                }}
              >
                <img
                  alt='check-device'
                  src={originalImage}
                  className='cursor-pointer transition-transform duration-300'
                  style={{
                    transform: `${
                      params.row.filePath &&
                      ((Number(rotate) > 90 && Number(rotate) < 270) ||
                        (Number(rotate) < -90 && Number(rotate) > -270))
                        ? `rotate(180deg)`
                        : 'rotate(0deg)'
                    }`,
                    width: 'auto',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                  onClick={(e) => {
                    handleCellClick(e)
                    imageDetailModalOpen()
                    setDeviceDetailData(params.row)
                  }}
                />
              </div>
            </div>
          )}
        </>
      )
    },
  }

  return [
    {
      field: 'officeName',
      headerName: '사업소 명',
      width: 120,
      flex: 120,
      resizable: false,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        return (
          <div className={'row text-center text-truncate gap-2 text-lg'}>
            <span className='text-truncate'>{params.row.officeId}</span>
            <span className='text-truncate'>{params.row.officeName}</span>
            <span className='text-truncate'>{params.row.cooperName}</span>
          </div>
        )
      },
    },
    {
      field: 'customerNumber',
      headerName: 'A/S',
      width: 190,
      flex: 190,
      resizable: false,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const {customerStatus, asInstallerName} = params.row
        return (
          <>
            <div
              className={'row w-100 h-100 text-center text-truncate'}
              style={{alignContent: 'center'}}
            >
              <span
                onClick={(e) => {
                  if (isPhotoModalOffice(officeInfo.value)) {
                    e.stopPropagation()
                    setTargetRowId(params.row.id)
                    setPhotoData(params.row)
                    photoModalOpen()
                  } else {
                    handleCellClick(e)
                    setCustomerDetailData(params.row)
                    customerDetailModalOpen()
                  }
                }}
                className={'text-hover-danger cursor-pointer text-primary fw-bold text-truncate'}
              >
                {globalFormatWithHyphens(params?.row?.officeId, params?.row?.customerNumber)}
              </span>

              <span className='text-danger'>{customerStatusHandler(customerStatus)}</span>
              {/* 할당은 A/S 접수(진행) 상태일 때만 노출 - asInstallerName 값만으로 표시하면
                  A/S 미접수 행에도 과거/미정리 배정자명이 뜨는 문제가 있어 상태로 게이트함 */}
              {customerStatus === 'as' && asInstallerName && (
                <span className='text-black text-lg'>할당 : {asInstallerName}</span>
              )}

              <div className={'fw-normal mt-8'}>
                {(() => {
                  const {customerStatus} = params.row
                  if (customerStatus === null || customerStatus === 'remove') {
                    return (
                      <Button
                        variant='outlined'
                        color='error'
                        disabled={asPending}
                        onClick={async (e) => {
                          handleCellClick(e)
                          onRequestAs
                            ? onRequestAs(params.row)
                            : registerAs(userInfo, [params.row], {promptCause: true, onDone: getcustomerInfo})
                        }}
                      >
                        A/S
                      </Button>
                    )
                  }
                  if (customerStatus === 'as') {
                    return (
                      <Button
                        variant='outlined'
                        color='error'
                        disabled={asPending}
                        onClick={async (e) => {
                          handleCellClick(e)
                          onCancelAs
                            ? onCancelAs(params.row)
                            : cancelAs(userInfo, [params.row], {onDone: getcustomerInfo})
                        }}
                      >
                        A/S 취소
                      </Button>
                    )
                  }
                  return ''
                })()}
              </div>
            </div>
          </>
        )
      },
    },
    {
      field: 'customerInfo',
      headerName: '주소',
      width: 280,
      flex: 280,
      resizable: false,
      align: 'left',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        return (
          <div className={'row text-truncate text-xl'}>
            <span className={'text-truncate'}>{params.row.customerName}</span>
            <span className='text-truncate'>
              <strong style={{color: '#104f98'}}>도로명 </strong> : {params.row.addressRoad}
            </span>
            <span className='text-truncate'>
              <strong style={{color: '#f37005'}}>지번 </strong> : {params.row.addressNumber}
            </span>
            {params.row.addressDetail && (
              <span className='text-truncate'>
                <strong style={{color: 'rgba(86,31,13,0.7)'}}>상세주소 </strong> :{' '}
                {params.row.addressDetail}
              </span>
            )}
            {params.row.managerName !== 'NULL' && (
              <span className='text-truncate'>
                <strong style={{color: 'rgba(29,61,37,0.7)'}}>담당자 </strong> :{' '}
                {params.row.managerName}
              </span>
            )}
            <span className='text-truncate'>
              <strong style={{color: '#038109'}}>설치자 </strong> : {params.row.installerName}
            </span>
          </div>
        )
      },
    },
    {
      field: 'efosStatus',
      headerName: '계량기',
      width: 110,
      flex: 110,
      resizable: false,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <>
            <div
              className='row w-100 h-100 text-center flex items-center justify-center'
              onClick={(e) => {
                handleCellClick(e)
              }}
            >
              <img
                className='max-w-[100px]'
                src={
                  params?.row.efosStatus ? selectSuccessEfos(cooperIdx) : selectFailEFos(cooperIdx)
                }
                alt={'efos-check'}
              />
            </div>
          </>
        )
      },
    },
    {
      field: 'deviceStatus',
      headerName: '단말기',
      resizable: false,
      width: 110,
      flex: 110,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <>
            <div
              className='row w-100 h-100 text-center flex items-center justify-center'
              onClick={(e) => {
                handleCellClick(e)
              }}
            >
              <img
                className='max-w-[100px]'
                alt={'device-check'}
                src={
                  params.row.deviceStatus ? selectSuccessImg(cooperIdx) : selectFailImg(cooperIdx)
                }
              />
            </div>
          </>
        )
      },
    },
    {
      field: 'deviceInfo',
      headerName: '배터리 / 구경',
      width: 150,
      flex: 150,
      resizable: false,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const serialNumber = globalSerialNumberFormatWithHyphens(params.row.serialNumber)
        const batteryLevel = params.row.batteryLevel
        const cooperIdx = params?.row.cooperIdx
        const showBattery = cooperIdx === 1 || cooperIdx === 0
        const meterDiameter = params?.row.meterDiameter
        return (
          <div className={'row text-center text-lg'}>
            <span>{serialNumber}</span>
            <span className={`${showBattery && batteryLevel < 30 ? 'text-danger' : 'text-dark'}`}>
              {showBattery ? `${batteryLevel} %` : '-'}
            </span>
            <span>{meterDiameter ? `${meterDiameter} mm` : '-'}</span>
          </div>
        )
      },
    },
    recentImageColumn,

    {
      field: 'checkInfo',
      headerName: '검침일',
      width: 160,
      flex: 160,
      resizable: false,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const status = params?.row?.processStatus
        const enumStatus = ImageProcessStatusEnum[status as keyof typeof ImageProcessStatusEnum]
        return (
          <div className={'row text-center'}>
            <div className={'d-flex justify-content-center'}>
              <span>
                {params.row.checkValue === '' || params.row.checkValue === null ? (
                  <span className={'text-danger'}>인식불가</span>
                ) : (
                  params.row.checkValue
                )}
              </span>
              <span>
                {params.row.checkDecimalValue === '' || params.row.checkDecimalValue === null
                  ? ''
                  : '.' + params.row.checkDecimalValue?.split('.')[1]}
              </span>
            </div>

            <div className='my-2'>
              <span className={`${status !== 'COMPLETE' ? 'text-warning' : ''}`}>{enumStatus}</span>
            </div>

            <span>{dayjs(params.row.efosConnectAt).format('YYYY-MM-DD')}</span>
          </div>
        )
      },
    },

    {
      field: 'review',
      headerName: '확인 필요 사유',
      width: 160,
      flex: 160,
      resizable: false,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const issueTypes: string[] = params.row.issueTypes ?? []
        const activeStatuses = flaggedReviewStatusOptions.filter((option) =>
          issueTypes.includes(option.key)
        )
        return (
          <div
            className='flex flex-wrap items-center justify-center gap-2 w-full h-full cursor-pointer'
            onClick={(e) => {
              handleCellClick(e)
              setDeviceDetailData(params.row)
              imageDetailModalOpen()
            }}
          >
            {activeStatuses.map((status) => (
              <CustomTag
                key={status.key}
                label={status.label}
                className={`text-xl px-3 py-3 ${status.badgeClassName}`}
              />
            ))}
          </div>
        )
      },
    },
  ]
}

export const customerStatusColumns = (
  imageDetailModalOpen: () => void,
  customerDetailModalOpen: () => void,
  setCustomerDetailData: any,
  setDeviceDetailData: any,
  cooperInfo: any,
  officeInfo: any,
  photoModalOpen: () => void,
  setPhotoData: any,
  setTargetRowId: any
) => {
  return [
    {
      field: 'officeName',
      headerName: '사업소 명',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center text-truncate'}>
            <span className={'text-truncate'}>{params.row.officeId}</span>
            <span className={'text-truncate'}>{params.row.officeName}</span>
          </div>
        )
      },
      width: 140,
      align: 'center',
      headerAlign: 'center',
    },

    {
      field: 'customerNumber',
      headerName: '계량기 번호',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <>
            <div className={'row w-100 h-100 text-center gap-2'} style={{alignContent: 'center'}}>
              <span
                onClick={(e) => {
                  if (isPhotoModalOffice(officeInfo.value)) {
                    e.stopPropagation()
                    setTargetRowId(params.row.id)
                    setPhotoData(params.row)
                    photoModalOpen()
                  } else {
                    handleCellClick(e)
                    setCustomerDetailData(params.row)
                    customerDetailModalOpen()
                  }
                }}
                className={'text-hover-danger cursor-pointer text-primary fw-bold text-truncate'}
              >
                {globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
              </span>

              <span className='text-truncate'>
                {params?.row.meterNumber !== '' ? params?.row.meterNumber : '-'}
              </span>
              <span>{params?.row.cooperName}</span>
            </div>
          </>
        )
      },
    },

    {
      field: 'customerInfo',
      headerName: '주소',
      sortable: false,
      renderCell: (params: any) => {
        return (
          <div
            className='row'
            onClick={(e) => {
              handleCellClick(e)
              setCustomerDetailData(params.row)
            }}
            style={{
              width: '100%',
              overflow: 'hidden', // 전체 셀의 넘치는 내용을 숨김 처리
            }}
          >
            <span className='d-block w-100 text-truncate'>{params.row.customerName}</span>
            <span className='d-block w-100 text-truncate'>
              <strong className='text-primary'>도로명 </strong>: {params.row.addressRoad}
            </span>
            <span className='d-block w-100 text-truncate'>
              <strong style={{color: '#f37005'}}>지번 </strong>: {params.row.addressNumber}
            </span>
            {params.row.addressDetail && (
              <span className='d-block w-100 text-truncate'>
                <strong style={{color: 'rgba(86,31,13,0.7)'}}>상세주소 </strong>:{' '}
                {params.row.addressDetail}
              </span>
            )}
            <span className='d-block w-100 text-truncate'>
              <strong style={{color: 'rgba(29,61,37,0.7)'}}>담당자 </strong>:{' '}
              {params.row.managerName}
            </span>
          </div>
        )
      },
      width: 240,
      align: 'left',
      headerAlign: 'center',
    },
    {
      field: 'deviceInfo',
      headerName: '배터리',
      sortable: false,
      renderCell: (params: any) => {
        const serialNumber = globalSerialNumberFormatWithHyphens(params.row.serialNumber)
        const batteryLevel = params.row.batteryLevel
        const cooperIdx = cooperInfo.value
        const customerStatus = params?.row?.customerStatus
        return (
          <div className={'row text-center'}>
            {customerStatus === 'remove' ? (
              <span className={'text-danger text-center'}>철거</span>
            ) : (
              <>
                <span>{serialNumber}</span>
                <span
                  className={`${
                    cooperIdx === 1 || cooperIdx === 0
                      ? batteryLevel < 30
                        ? 'text-danger'
                        : 'text-dark'
                      : 'text-dark'
                  }`}
                >
                  {cooperIdx === 1 || cooperIdx === 0 ? `${batteryLevel} %` : '-'}
                </span>
              </>
            )}
          </div>
        )
      },
      width: 150,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'customerDetail',
      headerName: '온도',
      width: 100,
      align: 'center',
      headerAlign: 'center',
      sortable: false,

      renderCell: (params: any) => {
        const temperature = params.row.temperature
        const meterDiameter = params?.row.meterDiameter

        return (
          <div className={'row text-center'}>
            <span>{meterDiameter ? `${meterDiameter} mm` : ''}</span>
            <span>
              {temperature !== 99 && showTemperatureHandler(serverLocalName, officeInfo.value)
                ? `${temperature}°C`
                : '-'}
            </span>
          </div>
        )
      },
    },
    ...(outerInstallShowHandler(serverLocalName, officeInfo.value)
      ? [
          {
            field: 'extraInfo',
            headerName: '외함',
            width: 180,
            align: 'left',
            headerAlign: 'center',
            renderCell: (params: any) => {
              const outerCaseInstalled = params?.row.isOuterCaseInstalled === true
              const outerCaseSize =
                params?.row.outerCaseSizeType === '소'
                  ? '小'
                  : params?.row.outerCaseSizeType === '대'
                  ? '大'
                  : ''
              const externalDisplayInstalled = params?.row.isExternalDisplayInstalled === true

              return (
                <div className='flex flex-col text-xl text-gray-800 leading-8 font-semibold'>
                  {externalDisplayInstalled && (
                    <div className='flex items-center gap-2'>
                      <div className='w-[7.5rem] tracking-wider'>외부표시장치</div>

                      <Chip label='설치' size='small' color='primary' className='px-1' />
                    </div>
                  )}
                  {outerCaseInstalled && (
                    <div className='flex items-center gap-2'>
                      <div className='w-[7.5rem] flex justify-between'>
                        <span>외</span>
                        <span>함{outerCaseSize ? `(${outerCaseSize})` : ''}</span>
                      </div>
                      <Chip label='설치' size='small' color='primary' className='px-1' />
                    </div>
                  )}
                </div>
              )
            },
          },
        ]
      : []),

    {
      field: 'efosStatus',
      headerName: '계량기',
      sortable: false,
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <>
            <img
              src={
                params?.row.efosStatus ? selectSuccessEfos(cooperIdx) : selectFailEFos(cooperIdx)
              }
              width={80}
            />
          </>
        )
      },
      width: 120,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'deviceStatus',
      headerName: '단말기',
      sortable: false,
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <img
            alt={'device_status'}
            src={params?.row.deviceStatus ? selectSuccessImg(cooperIdx) : selectFailImg(cooperIdx)}
            width={80}
          />
        )
      },
      width: 120,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'image',
      headerName: '이미지',
      width: 350,
      align: 'center',
      sortable: false,
      headerAlign: 'center',
      renderCell: (params: any) => {
        const rotate: string = params.row.rotate
        const recognizedType = params?.row?.recognizedType

        return (
          <>
            {params.row.deviceType !== 'analog' ? (
              <div
                className={
                  'cursor-pointer text-gray-500 w-full flex justify-center h-full items-center'
                }
                onClick={(e) => {
                  handleCellClick(e)
                  imageDetailModalOpen()
                  setDeviceDetailData(params.row)
                }}
              >
                NO IMAGE
              </div>
            ) : (
              <img
                className={'cursor-pointer'}
                alt={'check-device'}
                src={
                  params.row.filePath === null ? noImage : `${envImagePath}${params.row.filePath}`
                }
                style={{
                  transform: imageRotateHandler(rotate, officeInfo?.value, recognizedType),
                }}
                onClick={(e) => {
                  handleCellClick(e)
                  imageDetailModalOpen()
                  setDeviceDetailData(params.row)
                }}
              />
            )}
          </>
        )
      },
    },

    {
      field: 'checkInfo',
      headerName: '검침일',
      sortable: false,
      renderCell: (params: any) => {
        const isBlank = params.row.processStatus === 'NONE' && params.row.recognizedType === 'PRV'
        return (
          <div className={'row text-center'}>
            <div className={'d-flex justify-content-center'}>
              <span>
                {isBlank ? (
                  '-'
                ) : params.row.checkValue === '' || params.row.checkValue === null ? (
                  <span className={'text-danger'}>인식불가</span>
                ) : (
                  params.row.checkValue
                )}
              </span>
              <span>
                {params.row.checkDecimalValue === '' || params.row.checkDecimalValue === null
                  ? ''
                  : '.' + params.row.checkDecimalValue?.split('.')[1]}
              </span>
            </div>
            <span>{dayjs(params.row.efosConnectAt).format('YYYY-MM-DD')}</span>
          </div>
        )
      },
      width: 170,
      align: 'center',
      headerAlign: 'center',
    },
  ]
}

export const customerHmdColumns = (
  imageDetailModalOpen: () => void,
  customerDetailModalOpen: () => void,
  setCustomerDetailData: any,
  setDeviceDetailData: any,
  cooperInfo: any,
  officeInfo: any,
  photoModalOpen: () => void,
  setPhotoData: any,
  setTargetRowId: any
) => {
  return [
    {
      field: 'officeName',
      headerName: '사업소 명',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center text-truncate'}>
            <span className={'text-truncate'}>{params.row.officeId}</span>
            <span className={'text-truncate'}>{params.row.officeName}</span>
          </div>
        )
      },
      width: 140,
      align: 'center',
      headerAlign: 'center',
    },

    {
      field: 'customerNumber',
      headerName: '계량기 번호',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <>
            <div className={'row w-100 h-100 text-center gap-2'} style={{alignContent: 'center'}}>
              <span
                onClick={(e) => {
                  if (isPhotoModalOffice(officeInfo.value)) {
                    e.stopPropagation()
                    setTargetRowId(params.row.id)
                    setPhotoData(params.row)
                    photoModalOpen()
                  } else {
                    handleCellClick(e)
                    setCustomerDetailData(params.row)
                    customerDetailModalOpen()
                  }
                }}
                className={'text-hover-danger cursor-pointer text-primary fw-bold text-truncate'}
              >
                {globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
              </span>

              <span className='text-truncate'>
                {params?.row.meterNumber !== '' ? params?.row.meterNumber : '-'}
              </span>
              <span>{params?.row.cooperName}</span>
            </div>
          </>
        )
      },
    },

    {
      field: 'customerInfo',
      headerName: '주소',
      sortable: false,
      renderCell: (params: any) => {
        return (
          <div
            className='row'
            onClick={(e) => {
              handleCellClick(e)
              setCustomerDetailData(params.row)
            }}
            style={{
              width: '100%',
              overflow: 'hidden', // 전체 셀의 넘치는 내용을 숨김 처리
            }}
          >
            <span className='d-block w-100 text-truncate'>{params.row.customerName}</span>
            <span className='d-block w-100 text-truncate'>
              <strong className='text-primary'>도로명 </strong>: {params.row.addressRoad}
            </span>
            <span className='d-block w-100 text-truncate'>
              <strong style={{color: '#f37005'}}>지번 </strong>: {params.row.addressNumber}
            </span>
            {params.row.addressDetail && (
              <span className='d-block w-100 text-truncate'>
                <strong style={{color: 'rgba(86,31,13,0.7)'}}>상세주소 </strong>:{' '}
                {params.row.addressDetail}
              </span>
            )}
            <span className='d-block w-100 text-truncate'>
              <strong style={{color: 'rgba(29,61,37,0.7)'}}>담당자 </strong>:{' '}
              {params.row.managerName}
            </span>
          </div>
        )
      },
      width: 300,
      align: 'left',
      headerAlign: 'center',
    },
    {
      headerName: '단말기 SN',
      sortable: false,
      renderCell: (params: any) => {
        const serialNumber = globalSerialNumberFormatWithHyphens(params.row.serialNumber)
        const customerStatus = params?.row?.customerStatus
        return (
          <div className={'row text-center'}>
            {customerStatus === 'remove' ? (
              <span className={'text-danger text-center'}>철거</span>
            ) : (
              <>
                <span>{serialNumber}</span>
              </>
            )}
          </div>
        )
      },
      width: 150,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'customerDetail',
      headerName: '온도',
      width: 100,
      align: 'center',
      headerAlign: 'center',
      sortable: false,

      renderCell: (params: any) => {
        const temperature = params.row.temperature
        const meterDiameter = params?.row.meterDiameter

        return (
          <div className={'row text-center'}>
            <span>{meterDiameter ? `${meterDiameter} mm` : ''}</span>
            <span>
              {temperature !== 99 && showTemperatureHandler(serverLocalName, officeInfo.value)
                ? `${temperature}°C`
                : '-'}
            </span>
          </div>
        )
      },
    },
    ...(outerInstallShowHandler(serverLocalName, officeInfo.value)
      ? [
          {
            field: 'extraInfo',
            headerName: '외함',
            width: 180,
            align: 'left',
            headerAlign: 'center',
            renderCell: (params: any) => {
              const outerCaseInstalled = params?.row.isOuterCaseInstalled === true
              const outerCaseSize =
                params?.row.outerCaseSizeType === '소'
                  ? '小'
                  : params?.row.outerCaseSizeType === '대'
                  ? '大'
                  : ''
              const externalDisplayInstalled = params?.row.isExternalDisplayInstalled === true

              return (
                <div className='flex flex-col text-xl text-gray-800 leading-8 font-semibold'>
                  {externalDisplayInstalled && (
                    <div className='flex items-center gap-2'>
                      <div className='w-[7.5rem] tracking-wider'>외부표시장치</div>

                      <Chip label='설치' size='small' color='primary' className='px-1' />
                    </div>
                  )}
                  {outerCaseInstalled && (
                    <div className='flex items-center gap-2'>
                      <div className='w-[7.5rem] flex justify-between'>
                        <span>외</span>
                        <span>함{outerCaseSize ? `(${outerCaseSize})` : ''}</span>
                      </div>
                      <Chip label='설치' size='small' color='primary' className='px-1' />
                    </div>
                  )}
                </div>
              )
            },
          },
        ]
      : []),

    {
      field: 'efosStatus',
      headerName: '계량기',
      sortable: false,
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <>
            <img
              alt='yit_meter'
              src={
                params?.row.efosStatus ? selectSuccessEfos(cooperIdx) : selectFailEFos(cooperIdx)
              }
              width={80}
            />
          </>
        )
      },
      width: 120,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'deviceStatus',
      headerName: '단말기',
      sortable: false,
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <img
            alt={'device_status'}
            src={params?.row.deviceStatus ? selectSuccessImg(cooperIdx) : selectFailImg(cooperIdx)}
            width={80}
          />
        )
      },
      width: 120,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'image',
      headerName: '촬영시각',
      width: 350,
      align: 'center',
      sortable: false,
      headerAlign: 'center',
      renderCell: (params: any) => {
        const rotate: string = params.row.rotate
        const recognizedType = params?.row?.recognizedType

        return (
          <>
            {params.row.deviceType === 'analog' ? (
              <img
                className={'cursor-pointer'}
                alt={'check-device'}
                src={
                  params.row.latestImageFilePath === null
                    ? noImage
                    : `${envImagePath}${params.row.latestImageFilePath}`
                }
                style={{
                  transform: imageRotateHandler(rotate, officeInfo?.value, recognizedType),
                }}
                onClick={(e) => {
                  handleCellClick(e)
                  imageDetailModalOpen()
                  setDeviceDetailData(params.row)
                }}
              />
            ) : params.row.deviceType === 'hdm' ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '6px',
                }}
              >
                <img
                  className={'cursor-pointer'}
                  alt={'check-device'}
                  src={
                    params.row.latestImageFilePath === null
                      ? noImage
                      : `${hdmImageBackHost}/api/select/${params.row.latestImageFilePath}`
                  }
                  style={{
                    transform: imageRotateHandler(rotate, officeInfo?.value, recognizedType),
                  }}
                  onClick={(e) => {
                    handleCellClick(e)
                    imageDetailModalOpen()
                    setDeviceDetailData(params.row)
                  }}
                />

                {params.row.latestImageFilePath && (
                  <div
                    style={{
                      fontSize: '16px',
                      fontWeight: 600,
                      color: '#333',
                      textAlign: 'center',
                    }}
                  >
                    {dayjs(params?.row?.latestImageCreateAt).format('YYYY-MM-DD HH:mm:ss')}
                  </div>
                )}
              </div>
            ) : (
              <div
                className={
                  'cursor-pointer text-gray-500 w-full flex justify-center h-full items-center'
                }
                onClick={(e) => {
                  handleCellClick(e)
                  imageDetailModalOpen()
                  setDeviceDetailData(params.row)
                }}
              >
                NO IMAGE
              </div>
            )}
          </>
        )
      },
    },

    {
      field: 'checkInfo',
      headerName: '최신검침정보',
      sortable: false,
      renderCell: (params: any) => {
        const isBlank = params.row.processStatus === 'NONE' && params.row.recognizedType === 'PRV'
        return (
          <div className={'row text-center'}>
            <div className={'d-flex justify-content-center'}>
              <span>
                {isBlank ? (
                  '-'
                ) : params.row.checkValue === '' || params.row.checkValue === null ? (
                  <span className={'text-danger'}>인식불가</span>
                ) : (
                  params.row.checkValue
                )}
              </span>
              <span>
                {params.row.checkDecimalValue === '' || params.row.checkDecimalValue === null
                  ? ''
                  : '.' + params.row.checkDecimalValue?.split('.')[1]}
              </span>
            </div>
            <span>{dayjs(params.row.efosConnectAt).format('YYYY-MM-DD HH:mm:ss')}</span>
          </div>
        )
      },
      width: 170,
      align: 'center',
      headerAlign: 'center',
    },
  ]
}

export const customerStatusBoseongColumns = (
  imageDetailModalOpen: () => void,
  customerDetailModalOpen: () => void,
  setCustomerDetailData: any,
  setDeviceDetailData: any,
  cooperInfo: any,
  officeInfo: any,
  photoModalOpen: () => void,
  setPhotoData: any,
  setTargetRowId: any
) => {
  return [
    {
      field: 'customerNumber',
      headerName: '계량기 번호',
      minWidth: 180,
      flex: 1.5,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <>
            <div className={'row w-100 h-100 text-center gap-2'} style={{alignContent: 'center'}}>
              <span
                onClick={(e) => {
                  if (isPhotoModalOffice(officeInfo.value)) {
                    e.stopPropagation()
                    setTargetRowId(params.row.id)
                    setPhotoData(params.row)
                    photoModalOpen()
                  } else {
                    handleCellClick(e)
                    setCustomerDetailData(params.row)
                    customerDetailModalOpen()
                  }
                }}
                className={'text-hover-danger cursor-pointer text-primary fw-bold text-truncate'}
              >
                {globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
              </span>
              <span className='text-truncate'>
                {params?.row.meterNumber !== '' ? params?.row.meterNumber : ' - '}
              </span>
              <span>{params?.row.cooperName}</span>
            </div>
          </>
        )
      },
    },

    {
      field: 'customerInfo',
      headerName: '주소',
      width: 240,
      minWidth: 120,
      flex: 2,
      align: 'left',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <div
            className='row'
            onClick={(e) => {
              handleCellClick(e)
              setCustomerDetailData(params.row)
            }}
            style={{
              width: '100%',
              overflow: 'hidden', // 전체 셀의 넘치는 내용을 숨김 처리
            }}
          >
            <span className='d-block w-100 text-truncate'>{params.row.customerName}</span>
            <span className='d-block w-100 text-truncate'>
              <strong className='text-primary'>도로명 </strong>: {params.row.addressRoad}
            </span>
            <span className='d-block w-100 text-truncate'>
              <strong style={{color: '#f37005'}}>지번 </strong>: {params.row.addressNumber}
            </span>
            {params.row.addressDetail && (
              <span className='d-block w-100 text-truncate'>
                <strong style={{color: 'rgba(86,31,13,0.7)'}}>상세주소 </strong>:{' '}
                {params.row.addressDetail}
              </span>
            )}
            <span className='d-block w-100 text-truncate'>
              <strong style={{color: 'rgba(29,61,37,0.7)'}}>담당자 </strong>:{' '}
              {params.row.managerName}
            </span>
          </div>
        )
      },
    },
    {
      field: 'image',
      headerName: '이미지',
      maxWidth: 300,
      minWidth: 200,
      flex: 2.5,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const rotate: string = params.row.rotate
        return (
          <>
            {params.row.deviceType !== 'analog' ? (
              <div
                className={
                  'cursor-pointer text-gray-500 w-full flex justify-center h-full items-center'
                }
                onClick={(e) => {
                  handleCellClick(e)
                  imageDetailModalOpen()
                  setDeviceDetailData(params.row)
                }}
              >
                NO IMAGE
              </div>
            ) : (
              <img
                className={'cursor-pointer'}
                alt={'check-device'}
                src={
                  params.row.filePath === null ? noImage : `${envImagePath}${params.row.filePath}`
                }
                style={{
                  transform: params.row.filePath
                    ? (Number(rotate) > 90 && Number(rotate) < 270) ||
                      (Number(rotate) < -90 && Number(rotate) > -270)
                      ? `rotate(${rotate}deg)`
                      : `rotate(0deg)`
                    : `rotate(0deg)`,
                }}
                onClick={(e) => {
                  handleCellClick(e)
                  imageDetailModalOpen()
                  setDeviceDetailData(params.row)
                }}
              />
            )}
          </>
        )
      },
    },

    {
      field: 'checkInfo',
      headerName: '검침일',
      minWidth: 170,
      flex: 1.5,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center'}>
            <div className={'d-flex justify-content-center'}>
              <span>
                {params.row.checkValue === '' || params.row.checkValue === null ? (
                  <span className={'text-danger'}>인식불가</span>
                ) : (
                  params.row.checkValue
                )}
              </span>
              <span>
                {params.row.checkDecimalValue === '' || params.row.checkDecimalValue === null
                  ? ''
                  : '.' + params.row.checkDecimalValue?.split('.')[1]}
              </span>
            </div>
            <span>{dayjs(params.row.efosConnectAt).format('YYYY-MM-DD')}</span>
          </div>
        )
      },
    },

    {
      field: 'efosStatus',
      headerName: '계량기',
      width: 100,
      minWidth: 80,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <>
            <img
              src={
                params?.row.efosStatus ? selectSuccessEfos(cooperIdx) : selectFailEFos(cooperIdx)
              }
              style={{
                width: '100%',
                height: 'auto',
                maxWidth: '100px',
                objectFit: 'contain',
              }}
            />
          </>
        )
      },
    },
    {
      field: 'deviceStatus',
      headerName: '단말기',
      width: 100,
      minWidth: 80,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <img
            alt={'device_status'}
            src={params?.row.deviceStatus ? selectSuccessImg(cooperIdx) : selectFailImg(cooperIdx)}
            style={{
              width: '100%',
              height: 'auto',
              maxWidth: '100px',
              objectFit: 'contain',
            }}
          />
        )
      },
    },
    {
      field: 'deviceInfo',
      minWidth: 150,
      align: 'center',
      headerAlign: 'center',
      flex: 1,
      headerName: '배터리',
      renderCell: (params: any) => {
        const serialNumber = globalSerialNumberFormatWithHyphens(params.row.serialNumber)
        const batteryLevel = params.row.batteryLevel
        const cooperIdx = cooperInfo.value
        return (
          <div className={'row text-center'}>
            <span>{serialNumber}</span>
            <span
              className={`${
                cooperIdx === 1 || cooperIdx === 0
                  ? batteryLevel < 30
                    ? 'text-danger'
                    : 'text-dark'
                  : 'text-dark'
              }`}
            >
              {cooperIdx === 1 || cooperIdx === 0 ? `${batteryLevel} %` : '-'}
            </span>
          </div>
        )
      },
    },
    {
      field: 'customerDetail',
      headerName: '온도',
      minWidth: 100,
      flex: 0.5,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const temp = params.row.temperature
        const meterDiameter = params?.row.meterDiameter

        return (
          <div className={'row text-center'}>
            <span>{meterDiameter ? `${meterDiameter} mm` : ''}</span>

            <span>{temp < 90 ? `${temp}°C` : '-'}</span>
          </div>
        )
      },
    },
  ]
}

export const customerCheckListColumns: any = [
  {
    field: 'customerNumber',
    headerName: '수용가 번호',
    width: 180,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params: any) => {
      return (
        <div className='row text-center text-truncate gap-2'>
          <span className='text-truncate text-primary'>
            {globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
          </span>
          <span className='text-truncate'>{params.row.cooperName}</span>
        </div>
      )
    },
  },

  {
    field: 'customerInfo',
    headerName: '주소',
    renderCell: (params: any) => {
      return (
        <div className={'row gap-2 text-truncate'}>
          <span className='text-truncate'>{params.row.customerName}</span>
          <span className='text-truncate'>
            <strong style={{color: 'rgba(86,31,13,0.7)'}}>주소 :</strong> {params.row.address}
          </span>
          <span className='text-truncate'>
            <strong style={{color: 'rgba(29,61,37,0.7)'}}>담당자 :</strong> {params.row.managerName}
          </span>
        </div>
      )
    },
    width: 300,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'filePath',
    headerName: '검침 이미지',
    width: 1200,
    headerAlign: 'center',
    renderCell: (params: any) => {
      return (
        <div className={'custom-scrollbar overflow-auto w-100 h-100 pt-3 d-flex gap-6'}>
          {_.map(params.row.checkMeterList, (el, i) => {
            const rotate: string = el?.rotate
            return (
              <div key={i}>
                <div className={'row text-center mx-2'} style={{width: '250px'}}>
                  <div>{dayjs(el?.idxDate?.slice(0, 8))?.format('YYYY년 MM월 DD일')}</div>
                  <div className='w-[320px] h-[120px] flex items-center justify-center overflow-hidden'>
                    <img
                      alt='check-image'
                      src={el?.filePath === null ? defaultImage : envImagePath + el?.filePath}
                      className='h-full w-auto object-contain'
                      style={{
                        transform: el?.filePath
                          ? (Number(rotate) > 90 && Number(rotate) < 270) ||
                            (Number(rotate) < -90 && Number(rotate) > -270)
                            ? `rotate(180deg)`
                            : `rotate(0deg)`
                          : `rotate(0deg)`,
                      }}
                    />
                  </div>
                  <div>
                    {el?.recognizedType === 'PRV' ? (
                      <span>검침값 : -</span>
                    ) : el?.filePath !== null ? (
                      <span>검침값 : {el?.checkValue === '' ? '없음' : el?.checkValue}</span>
                    ) : (
                      <span>
                        검침값 :{' '}
                        {(Number(el?.checkValue) + Number(el?.checkDecimalValue))?.toFixed(3)}
                      </span>
                    )}
                  </div>
                  <div>
                    <span>사용량 : {el?.use}t</span>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      )
    },
  },
]

export const customerCheckReportColumns: any = (
  checkReportList: any,
  updateValue: any,
  setUpdateValue: any,
  updateHandler: () => void,
  setCheckReportList: any
) => {
  return [
    {
      field: 'customerNumber',
      headerName: '수용가 번호',
      width: 200,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <div className='row text-truncate text-center gap-2'>
            <span className={'text-primary text-truncate'}>
              {globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
            </span>
            <span className={'text-truncate'}>{params.row.cooperName}</span>
          </div>
        )
      },
    },
    {
      field: 'customerName',
      headerName: '정보',
      width: 280,
      align: 'left',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <div className={'row px-0 mx-0 gap-3'}>
            <span>{params.row.customerName}</span>
            <span>
              <strong style={{color: 'rgba(86,31,13,0.7)'}}>주소 </strong>: {params.row.address}
            </span>
            <span>
              {' '}
              <strong style={{color: 'rgba(29,61,37,0.7)'}}>담당자</strong> :{' '}
              {params.row.managerName}
            </span>
          </div>
        )
      },
    },

    {
      field: 'meterDiameter',
      headerName: '구경',
      width: 70,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <span>
            {params.row.meterDiameter === '없음' ? '미등록' : params.row.meterDiameter + 'mm'}
          </span>
        )
      },
    },

    {
      field: 'checkDay',
      headerName: '검침일',
      width: 110,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return <span>{params.row.checkDay} 일</span>
      },
    },
    {
      field: 'startFilePath',
      headerName: '전월 이미지',
      width: 350,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const startRotate: string = params.row.startRotate
        if (params.row.startRecognizedType === 'PRV' && params.row.startFilePath) {
          return (
            <img
              className='p-3'
              src={envImagePath + params.row.startFilePath}
              alt='device'
              style={{
                transform:
                  (Number(startRotate) > 90 && Number(startRotate) < 270) ||
                  (Number(startRotate) < -90 && Number(startRotate) > -270)
                    ? `rotate(180deg)`
                    : `rotate(0deg)`,
              }}
            />
          )
        }
        return (
          <>
            {params.row.deviceType === 'analog' && params.row.startCheckValue === null ? (
              <span className={'text-danger'}>검침 데이터 수집 중입니다.</span>
            ) : (
              <img
                className={'p-3'}
                src={envImagePath + params.row.startFilePath}
                alt={'device'}
                style={{
                  transform: params.row.startFilePath
                    ? (Number(startRotate) > 90 && Number(startRotate) < 270) ||
                      (Number(startRotate) < -90 && Number(startRotate) > -270)
                      ? `rotate(180deg)`
                      : `rotate(0deg)`
                    : `rotate(0deg)`,
                }}
              />
            )}
            {params.row.deviceType === 'digital' &&
              (params.row.startCheckValue === null ? (
                <span className={'text-danger'}>검침 데이터 수집 중입니다.</span>
              ) : (
                <img className={'p-3'} src={defaultImage} alt={'default'} />
              ))}
          </>
        )
      },
    },
    {
      field: 'startIdxDate',
      headerName: '전월일',
      width: 160,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        if (params.row.startRecognizedType === 'PRV' && params.row.startFilePath) {
          return <span>{dayjs(params.row.startIdxDate).format('YYYY년 MM월 DD일')}</span>
        }
        return (
          <>
            {params.row.deviceType === 'analog' &&
              (params.row.startCheckValue === null ? (
                <span></span>
              ) : (
                <span>{dayjs(params.row.startIdxDate).format('YYYY년 MM월 DD일')}</span>
              ))}
            {params.row.deviceType === 'digital' &&
              (params.row.startCheckValue === null ? (
                <span></span>
              ) : (
                <span>{dayjs(params.row.startIdxDate).format('YYYY년 MM월 DD일')}</span>
              ))}
          </>
        )
      },
    },
    {
      field: 'endFilePath',
      headerName: '당월 이미지',
      width: 350,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const endRotate: string = params.row.endRotate
        if (params.row.endRecognizedType === 'PRV' && params.row.endFilePath) {
          return (
            <img
              className='p-3'
              src={envImagePath + params.row.endFilePath}
              alt='device'
              style={{
                transform:
                  (Number(endRotate) > 90 && Number(endRotate) < 270) ||
                  (Number(endRotate) < -90 && Number(endRotate) > -270)
                    ? `rotate(180deg)`
                    : `rotate(0deg)`,
              }}
            />
          )
        }
        return (
          <>
            {params.row.deviceType === 'analog' &&
              (params.row.endCheckValue === null ? (
                <span className={'text-danger'}>검침 데이터 수집 중입니다.</span>
              ) : (
                <img
                  className={'p-3'}
                  src={envImagePath + params.row.endFilePath}
                  alt={'device'}
                  style={{
                    transform: params.row.endFilePath
                      ? (Number(endRotate) > 90 && Number(endRotate) < 270) ||
                        (Number(endRotate) < -90 && Number(endRotate) > -270)
                        ? `rotate(180deg)`
                        : `rotate(0deg)`
                      : `rotate(0deg)`,
                  }}
                />
              ))}
            {params.row.deviceType === 'digital' &&
              (params.row.endCheckValue === null ? (
                <span className={'text-danger'}>검침 데이터 수집 중입니다.</span>
              ) : (
                <img className={'p-3'} src={defaultImage} alt={'default'} />
              ))}
          </>
        )
      },
    },
    {
      field: 'endIdxDate',
      headerName: '당월일',
      width: 160,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        if (params.row.endRecognizedType === 'PRV' && params.row.endFilePath) {
          return <span>{dayjs(params.row.endIdxDate).format('YYYY년 MM월 DD일')}</span>
        }
        return (
          <>
            {params.row.endCheckValue === null ? (
              <span></span>
            ) : (
              <span>{dayjs(params.row.endIdxDate).format('YYYY년 MM월 DD일')}</span>
            )}
          </>
        )
      },
    },
    {
      field: 'updateValue',
      headerName: '전월값 및 당월값 수정',
      width: 350,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        let startCheckValue = params.row.startCheckValue
        let endCheckValue = params.row.endCheckValue
        return (
          <>
            {checkReportList && params.row.cooperIdx === '1' && (
              <div className='d-flex justify-content-center gap-2'>
                <TextField
                  type={'text'}
                  label='전월값'
                  variant='outlined'
                  size='small'
                  className='mx-1'
                  value={startCheckValue !== null ? startCheckValue : ''}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => {
                    if (e.ctrlKey && e.key === 'a') {
                      e.stopPropagation()
                    }
                    if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                      e.stopPropagation()
                    }
                  }}
                  onChange={(e) => {
                    const inputValue = Number(e.target.value)

                    if (!isNaN(inputValue)) {
                      const updateValue = [...checkReportList]
                      updateValue[params.row.id - 1].startCheckValue = inputValue
                      setCheckReportList(updateValue)
                    }

                    setUpdateValue({
                      ...updateValue,
                      startImei: params.row.startImei,
                      startValue: e.target.value,
                      startIdxDate: params.row.startIdxDate,
                    })
                  }}
                />
                <TextField
                  type={'text'}
                  label='당월값'
                  variant='outlined'
                  size='small'
                  className='mx-1'
                  value={endCheckValue !== null ? endCheckValue : ''}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => {
                    if (e.ctrlKey && e.key === 'a') {
                      e.stopPropagation()
                    }
                    if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                      e.stopPropagation()
                    }
                  }}
                  onChange={(e) => {
                    const inputValue = Number(e.target.value)

                    if (!isNaN(inputValue)) {
                      const updateValue = [...checkReportList]
                      updateValue[params.row.id - 1].endCheckValue = inputValue
                      setCheckReportList(updateValue)
                    }
                    setUpdateValue({
                      ...updateValue,
                      imei: params.row.endImei,
                      value: e.target.value,
                      idxDate: params.row.endIdxDate,
                    })
                  }}
                />
                <Button
                  variant='contained'
                  size='small'
                  className='mx-1'
                  onClick={() => updateHandler()}
                >
                  수정
                </Button>
              </div>
            )}
            {checkReportList && params.row.cooperIdx !== '1' && (
              <div className='d-flex justify-content-center gap-2'>
                <TextField
                  id='outlined-basic'
                  type={'text'}
                  label='전월값'
                  variant='outlined'
                  size='small'
                  disabled
                  className='mx-1'
                  value={
                    Number(params?.row?.startCheckValue) +
                    Number(params?.row?.startCheckDecimalValue)
                  }
                />
                <TextField
                  id='outlined-basic'
                  type={'text'}
                  label='당월값'
                  variant='outlined'
                  size='small'
                  disabled
                  className='mx-1'
                  value={
                    Number(params?.row?.endCheckValue) + Number(params?.row?.endCheckDecimalValue)
                  }
                />
              </div>
            )}
          </>
        )
      },
    },
  ]
}

export const customerMinimumFlowColumns = (filter: any) => {
  return [
    {
      field: 'customerNumber',
      headerName: '수용가 번호',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <div className='text-truncate text-center gap-2 row'>
            <span className={'text-primary text-truncate'}>
              {globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
            </span>
            <span>{params.row.cooperName}</span>
          </div>
        )
      },
    },
    {
      field: 'customerName',
      headerName: '이름',
      width: 200,
      align: 'left',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <div className='text-truncate gap-2 row'>
            <span className='text-truncate'>{params.row.customerName}</span>
            <span className='text-truncate'>
              <strong style={{color: 'rgba(86,31,13,0.7)'}}>주소 </strong> :{params.row.address}
            </span>
            <span className='text-truncate'>
              <strong style={{color: 'rgba(29,61,37,0.7)'}}>담당자 </strong> :{' '}
              {params.row.managerName}
            </span>
          </div>
        )
      },
    },
    {
      field: 'totalUsage',
      headerName: '총 사용량',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return <span>{Number(params.row.totalUsage)?.toFixed(3) + 't'}</span>
      },
    },
    {
      field: 'forOneHourUsage',
      headerName: '1시간 사용량',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <span>
            {'약 ' +
              (Number(params.row.totalUsage) / (filter.end - filter.start))?.toFixed(4) +
              't'}
          </span>
        )
      },
    },
    {
      field: 'checkMeterList',
      headerName: `${dayjs(filter.date).format('YYYY년 MM월 DD일')} / ${filter.start}시 00분 ~ ${
        filter.end
      }시 59분 검침이미지`,
      width: 1100,
      headerAlign: 'center',
      cellClassName: 'overflow-scroll',
      sortable: false,

      renderCell: (params: any) => {
        return (
          <div className={'custom-scrollbar overflow-auto w-100 h-100 pt-3 d-flex gap-6'}>
            {_.map(params.row.checkMeterList, (el, i) => {
              const rotate: string = el?.rotate
              return (
                <>
                  <div className={'row text-center mx-2'} style={{width: '250px'}}>
                    <div>
                      {el?.createAt === null
                        ? ''
                        : dayjs(el?.createAt).format('MM월 DD일 HH시 mm분')}
                    </div>
                    <div>
                      {el?.filePath === null ? (
                        <div
                          className={
                            'cursor-pointer text-gray-500 w-full flex justify-center h-[100px] items-center '
                          }
                        >
                          NO IMAGE
                        </div>
                      ) : (
                        <img
                          src={envImagePath + el?.filePath}
                          alt={'check-image'}
                          style={{
                            transform: el?.filePath
                              ? (Number(rotate) > 90 && Number(rotate) < 270) ||
                                (Number(rotate) < -90 && Number(rotate) > -270)
                                ? `rotate(180deg)`
                                : `rotate(0deg)`
                              : `rotate(0deg)`,
                          }}
                          width={el?.filePath === null ? 80 : '250px'}
                        />
                      )}
                    </div>

                    <div>
                      {el?.filePath !== null ? (
                        <span>
                          검침값 :
                          <u>
                            {el?.checkValue === '' || el?.checkValue === null
                              ? '없음'
                              : el?.checkValue}
                          </u>
                        </span>
                      ) : (
                        <span>
                          검침값 :
                          <u>
                            {el?.checkValue === '' || el?.checkValue === null
                              ? '-'
                              : (Number(el.checkValue) + Number(el.checkDecimalValue))?.toFixed(3)}
                          </u>
                        </span>
                      )}
                    </div>
                    <div>
                      <span>사용량 : {el.use}t</span>
                    </div>
                  </div>
                </>
              )
            })}
          </div>
        )
      },
    },
  ]
}

export const customerLeakageColumns = (
  filter: any,
  imageDetailModalOpen: () => void,
  setDeviceDetailData: any
) => {
  return [
    {
      field: 'customerNumber',
      headerName: '수용가 번호',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <>
            <div className='row text-truncate gap-2'>
              <span className={'text-hover-danger cursor-pointer text-primary fw-bold'}>
                {globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
              </span>
              <span className={'text-truncate text-center'}>{params.row.cooperName}</span>
            </div>
          </>
        )
      },
    },

    {
      field: 'customerName',
      headerName: '주소',
      renderCell: (params: any) => {
        return (
          <div className={'row text-truncate gap-2'}>
            <span className={'text-truncate'}>{params.row.customerName}</span>
            <span className={'text-truncate'}>
              <strong style={{color: '#104f98'}}>주소 </strong> :{params.row.addressRoad}
            </span>
            <span className={'text-truncate'}>
              <strong style={{color: 'rgba(29,61,37,0.7)'}}>담당자 </strong>:
              {params.row.managerName}
            </span>
          </div>
        )
      },
      width: 250,
      align: 'left',
      headerAlign: 'center',
    },

    {
      field: 'leakFilePath',
      headerName: '이미지',
      width: 300,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <>
            {params.row.todayFilePath === '' ||
            params.row.todayFilePath === null ||
            params.row.todayFilePath === 'null' ? (
              <div className={'row text-center justify-content-center gap-2'}>
                <img
                  onClick={(e) => {
                    setDeviceDetailData(params.row)
                    handleCellClick(e)
                    imageDetailModalOpen()
                  }}
                  src={defaultImage}
                  style={{width: '80px'}}
                  className={'cursor-pointer'}
                />
                <span className={'text-danger'}>
                  누수의심 기준 : 약 {Number(params.row.avg).toFixed(3)}t
                </span>
              </div>
            ) : (
              <div className={'row text-center justify-content-center gap-2'}>
                <img
                  onClick={(e) => {
                    setDeviceDetailData(params.row)
                    handleCellClick(e)
                    imageDetailModalOpen()
                  }}
                  className={'cursor-pointer'}
                  src={envImagePath + params.row.todayFilePath}
                />
                <span className={'text-danger'}>
                  누수의심 기준 : 약 {Number(params.row.avg).toFixed(3)}t
                </span>
              </div>
            )}
          </>
        )
      },
    },

    {
      field: 'checkInfo',
      headerName: '검침정보',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center'}>
            <span>{dayjs(params.row.todayIdxDate).format('YYYY-MM-DD')}</span>
          </div>
        )
      },
      width: 150,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'checkList',
      headerName: '차트',
      renderCell: (params: any) => {
        return (
          <LeakViewChart
            className={'p-3 w-100'}
            filter={filter}
            checkList={params.row.checkList}
            avg={params.row.avg}
          />
        )
      },
      width: 1330,
      align: 'center',
      headerAlign: 'center',
    },
  ]
}

export const customerLeakageColumnsBongHwa = (
  filter: any,
  imageDetailModalOpen: () => void,
  setDeviceDetailData: any
) => {
  return [
    {
      field: 'customerNumber',
      headerName: '수용가 정보',
      width: 300,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const managerName = params?.row?.managerName

        return (
          <>
            <div className={'row text-truncate gap-2'}>
              <span
                className={
                  'text-hover-danger text-center cursor-pointer text-primary fw-bold text-truncate'
                }
              >
                {globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
              </span>
              <span className={'text-truncate text-center mb-2'}>{params.row.cooperName}</span>
              <span className={'text-truncate'}>{params.row.customerName}</span>
              <span className={'text-truncate'}>
                <strong style={{color: '#104f98'}}>주소 </strong> :{params.row.addressRoad}
              </span>
              <span className={'text-truncate'}>
                <strong style={{color: 'rgba(29,61,37,0.7)'}}>담당자 </strong>:
                {managerName === null || managerName === 'null' ? '-' : managerName}
              </span>
            </div>
          </>
        )
      },
    },
    {
      field: 'leakFilePath',
      headerName: '이미지',
      width: 240,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const rotate = params?.row?.checkList?.filter(
          (item: any) => item?.idxDate === params?.row?.todayIdxDate
        )[0]?.rotate

        return (
          <>
            {params.row.todayFilePath === '' ||
            params.row.todayFilePath === null ||
            params.row.todayFilePath === 'null' ? (
              <div className={'row text-center justify-content-center gap-2'}>
                <img
                  onClick={(e) => {
                    setDeviceDetailData(params.row)
                    handleCellClick(e)
                    imageDetailModalOpen()
                  }}
                  src={defaultImage}
                  style={{width: '80px'}}
                  className={'cursor-pointer'}
                />
              </div>
            ) : (
              <div className={'row text-center justify-content-center gap-2'}>
                <img
                  onClick={(e) => {
                    setDeviceDetailData(params.row)
                    handleCellClick(e)
                    imageDetailModalOpen()
                  }}
                  className={'cursor-pointer'}
                  style={{
                    transform: params.row.todayFilePath
                      ? (Number(rotate) > 90 && Number(rotate) < 270) ||
                        (Number(rotate) < -90 && Number(rotate) > -270)
                        ? `rotate(${rotate}deg)`
                        : `rotate(0deg)`
                      : `rotate(0deg)`,
                  }}
                  src={envImagePath + params.row.todayFilePath}
                />
              </div>
            )}
          </>
        )
      },
    },
    {
      field: 'leakUsed',
      headerName: '사용량',
      width: 220,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const cycles =
          params.row.leakUseCycle === '일'
            ? '1일'
            : params.row.leakUseCycle === '주'
            ? '1주일'
            : '1개월'
        const startDate = dayjs(params.row.calStartDate).format('MM월 DD일')
        const endDate = dayjs(params.row.calEndDate).format('MM월 DD일')
        const today = dayjs(params.row.todayIdxDate.slice(0, 8)).format('MM월 DD일')
        return (
          <>
            <div className={'row text-start gap-2 text-truncate'}>
              <Tooltip
                TransitionComponent={Fade}
                TransitionProps={{timeout: 600}}
                title={
                  <span className={'fs-6'}>
                    {startDate}부터 {endDate}까지 사용량
                  </span>
                }
              >
                <span className={'cursor-pointer text-primary fw-bold text-truncate'}>
                  지난 {cycles} 사용량 : {params.row.usedAmountUntilRecent}t
                </span>
              </Tooltip>

              <Tooltip
                TransitionComponent={Fade}
                TransitionProps={{timeout: 600}}
                title={
                  <span className={'fs-6'}>
                    {endDate}부터 {today}까지 사용량
                  </span>
                }
              >
                <span className='text-truncate'>
                  최근 {cycles} 사용량 : {params.row.usedAmountUntilToday}t
                </span>
              </Tooltip>
            </div>
          </>
        )
      },
    },

    {
      field: 'checkList',
      headerName: '차트',
      width: 1330,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <LeakViewChartBongHwa
            className={'p-3 w-100'}
            filter={filter}
            checkList={params.row.checkList}
            avg={params.row.avg}
          />
        )
      },
    },
  ]
}

export const customerLeakageDetailUncertainListColumns = (filter: any) => {
  return [
    {
      field: 'customerNumber',
      headerName: '수용가 번호 / 이름',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center text-truncate fs-5'}>
            <div className={'text-primary'}>
              {globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
            </div>
            <div className={'text-truncate '}>{params.row.customerName}</div>
          </div>
        )
      },
    },
    {
      field: 'customerAddress',
      headerName: '주소',
      width: 420,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        return (
          <div className={'row text-center text-truncate fs-5'}>
            <div className={'text-truncate'}>{params.row.address}</div>
          </div>
        )
      },
    },
    {
      field: 'customerLatestImage',
      headerName: '마지막 검침 이미지',
      width: 200,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const rotate = params?.row.rotate
        return (
          <div className={'row text-center fs-5'}>
            <img
              src={`${envImagePath}${params.row.filePath}`}
              alt='id-logo'
              className={'img-fluid'}
              loading={'lazy'}
              style={{
                transform: params.row.filePath
                  ? (Number(rotate) > 90 && Number(rotate) < 270) ||
                    (Number(rotate) < -90 && Number(rotate) > -270)
                    ? `rotate(${rotate}deg)`
                    : `rotate(0deg)`
                  : `rotate(0deg)`,
              }}
            />
            <span>{dayjs(params.row.lastIdxDate.slice(0, 8)).format(`YYYY년 MM월 DD일`)}</span>
          </div>
        )
      },
    },
  ]
}

export const customerLongTermUnusedColumn = (filter: any) => {
  return [
    {
      field: 'customerNumber',
      headerName: '수용가 번호',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center text-truncate gap-4 fs-5'}>
            <div className={'text-primary'}>
              {globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
            </div>
            <div className={''}>{params.row.cooperName}</div>
          </div>
        )
      },
    },
    {
      field: 'customerName',
      headerName: '이름',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        return (
          <div className={'row text-center text-truncate fs-5'}>
            <div className={'text-truncate '}>{params.row.customerName}</div>
          </div>
        )
      },
    },

    {
      field: 'customerAddress',
      headerName: '주소',
      width: 420,
      align: 'center',
      headerAlign: 'center',
      sortable: false,

      renderCell: (params: any) => {
        return (
          <div className={'row  text-truncate fs-5 gap-4'}>
            <div className={'text-truncate '}>
              <strong style={{color: '#104f98'}}>주소 </strong> :{params.row.address}
            </div>
            <div className={'text-truncate '}>
              <strong style={{color: 'rgba(29,61,37,0.7)'}}>담당자 </strong>:
              {params.row.managerName}
            </div>
          </div>
        )
      },
    },
    {
      field: 'customerImage ',
      headerName: '이미지',
      width: 600,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params: any) => {
        const rotate = params.row.rotate
        return (
          <div className={'d-flex gap-4'}>
            <div className={'row text-center fs-5 gap-2'}>
              <img
                src={`${envImagePath}${params.row.longtermDayFilePath}`}
                alt='id-logo'
                className={'img-fluid'}
                loading={'lazy'}
                style={{
                  transform: params.row.longtermDayFilePath
                    ? (Number(rotate) > 90 && Number(rotate) < 270) ||
                      (Number(rotate) < -90 && Number(rotate) > -270)
                      ? `rotate(${rotate}deg)`
                      : `rotate(0deg)`
                    : `rotate(0deg)`,
                }}
              />
              <span>
                검침값 :{' '}
                <span style={{textDecoration: 'underline'}}>
                  {params.row.longtermDayCheckValue}
                </span>
              </span>
              <span>
                {dayjs(params.row.longtermDayIdxDate && params?.row?.longtermDayIdxDate).format(
                  `YYYY년 MM월 DD일`
                )}
              </span>
            </div>
            <div className={'row text-center fs-5 gap-2'}>
              <img
                src={`${envImagePath}${params.row.todayFilePath}`}
                alt='id-logo'
                className={'img-fluid'}
                loading={'lazy'}
                style={{
                  transform: params.row.todayFilePath
                    ? (Number(rotate) > 90 && Number(rotate) < 270) ||
                      (Number(rotate) < -90 && Number(rotate) > -270)
                      ? `rotate(${rotate}deg)`
                      : `rotate(0deg)`
                    : `rotate(0deg)`,
                }}
              />
              <span>
                검침값 :{' '}
                <span style={{textDecoration: 'underline'}}>{params.row.todayCheckValue}</span>
              </span>
              <span>
                {dayjs(params.row.todayIdxDate && params?.row?.todayIdxDate).format(
                  `YYYY년 MM월 DD일`
                )}
              </span>
            </div>
          </div>
        )
      },
    },
  ]
}

export const customerFreezeWarningColumns = (filter: any) => {
  const chipValue = (value: string) => {
    switch (value) {
      case null:
        return '기계식'
      case 'analog':
        return '기계식'
      case 'digital':
        return '디지털'
      case 'gas':
        return '가스'
      case 'PRV':
        return '압력게이지'
      default:
        return '기계식'
    }
  }
  const chipColor = (value: string) => {
    switch (value) {
      case null:
      case 'analog':
        return 'bg-rose-600 text-white'
      case 'digital':
        return 'bg-amber-500 text-white'
      case 'gas':
        return 'bg-green-700 text-white'
      case 'PRV':
        return 'bg-indigo-700 text-white'
      default:
        return 'bg-red-500 text-white'
    }
  }
  return [
    {
      field: 'customerNumber',
      headerName: '동파 구분',
      width: 180,
      align: 'center',
      headerAlign: 'center',

      renderCell: (params: any) => {
        const temp = params.row.currentTemperature
        return (
          <div className='row gap-2'>
            <div className={'row w-100 h-100 text-center gap-2'} style={{alignContent: 'center'}}>
              <span className={'text-primary text-truncate fw-bold'}>
                {globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
              </span>
              <span className={'text-truncate'}>{params.row.cooperName}</span>
            </div>
            <div className={'row text-center'}>
              {temp < 90 ? (
                temp > -1 ? (
                  <span className={'text-primary'}>양호</span>
                ) : temp >= -3 ? (
                  <span className={'text-warning'}>주의</span>
                ) : temp >= -5 ? (
                  <span style={{color: 'orange'}}>위험</span>
                ) : (
                  <span className={'text-danger'}>매우위험</span>
                )
              ) : (
                <span className={''}>-</span>
              )}
            </div>
          </div>
        )
      },
    },
    {
      field: 'officeName',
      headerName: '사업소 명',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center text-truncate'}>
            <span className={'text-truncate'}>{params.row.officeId}</span>
            <span className={'text-truncate'}>{params.row.officeName}</span>
          </div>
        )
      },
      width: 140,
      align: 'center',
      headerAlign: 'center',
    },

    {
      field: 'customerInfo',
      headerName: '주소',
      renderCell: (params: any) => {
        return (
          <div className={'row text-truncate'}>
            <span className={'text-truncate'}>{params.row.customerName}</span>
            <span className={'text-truncate'}>
              <strong style={{color: '#104f98'}}>도로명 </strong> : {params.row.addressRoad}{' '}
            </span>
            <span className={'text-truncate'}>
              <strong style={{color: '#f37005'}}>지번 </strong> : {params.row.addressNumber}{' '}
            </span>
            {params.row.addressDetail && (
              <span className={'text-truncate'}>
                <strong style={{color: 'rgba(86,31,13,0.7)'}}>상세주소 </strong> :{' '}
                {params.row.addressDetail}{' '}
              </span>
            )}
            {params.row.managerName !== 'NULL' && (
              <span className={'text-truncate'}>
                <strong style={{color: 'rgba(29,61,37,0.7)'}}>담당자 </strong> :{' '}
                {params.row.managerName}{' '}
              </span>
            )}
          </div>
        )
      },
      width: 260,
      align: 'left',
      headerAlign: 'center',
    },
    {
      field: 'deviceInfo',
      headerName: '배터리',
      renderCell: (params: any) => {
        const serialNumber = globalSerialNumberFormatWithHyphens(params.row.serialNumber)
        return (
          <div className={'row text-center'}>
            <span>{serialNumber}</span>
            <span className={`${params.row.batteryLevel < 30 ? 'text-danger' : 'text-dark'}`}>
              {params.row.batteryLevel} %
            </span>
          </div>
        )
      },
      width: 140,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'customerDetail',
      headerName: '온도',
      width: 140,
      align: 'center',
      headerAlign: 'center',

      renderCell: (params: any) => {
        const temp = params.row.currentTemperature
        const meterDiameter = params?.row.meterDiameter

        return (
          <div className={'row text-center'}>
            <span>{meterDiameter ? `${meterDiameter} mm` : ''}</span>
            <span>{temp < 90 ? `${temp}°C` : '-'}</span>
          </div>
        )
      },
    },

    {
      field: 'efosStatus',
      headerName: '계량기',
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <>
            <div className={'row w-100 h-100 text-center '} style={{alignContent: 'center'}}>
              <img
                src={
                  params?.row.efosStatus ? selectSuccessEfos(cooperIdx) : selectFailEFos(cooperIdx)
                }
                width={80}
                alt={'meter-check'}
              />
            </div>
          </>
        )
      },
      width: 120,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'deviceStatus',
      headerName: '단말기',
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <>
            <div className={'row w-100 h-100 text-center '} style={{alignContent: 'center'}}>
              <img
                alt={'device-check'}
                src={
                  params.row.deviceStatus ? selectSuccessImg(cooperIdx) : selectFailImg(cooperIdx)
                }
                width={80}
              />
            </div>
          </>
        )
      },
      width: 120,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'image',
      headerName: '이미지',
      width: 340,
      align: 'center',

      headerAlign: 'center',
      renderCell: (params: any) => {
        const rotate: string = params.row.rotate
        return (
          <>
            {params.row.deviceType !== 'analog' ? (
              <img className={'cursor-pointer'} src={defaultImage} alt={'default'} />
            ) : (
              <div className={'row'}>
                <div
                  className={'d-flex gap-1 justify-content-end'}
                  style={{position: 'relative', top: '15px', zIndex: 888}}
                >
                  {params.row.rotate !== 0 && (
                    <Chip
                      label={`${params.row.rotate}° `}
                      color='primary'
                      sx={{fontSize: '17px'}}
                    />
                  )}

                  <CustomTag
                    label={chipValue(params.row.recognizedType)}
                    className={`text-[17px] h-[30px] ${chipColor(params.row.recognizedType)}`}
                  />
                </div>
                <img
                  alt={'device'}
                  className={'cursor-pointer'}
                  src={
                    params.row.filePath === null ? noImage : `${envImagePath}${params.row.filePath}`
                  }
                  style={{
                    transform: params.row.filePath
                      ? (Number(rotate) > 90 && Number(rotate) < 270) ||
                        (Number(rotate) < -90 && Number(rotate) > -270)
                        ? `rotate(${rotate}deg)`
                        : `rotate(0deg)`
                      : `rotate(0deg)`,
                  }}
                  width={320}
                  height={144}
                />
              </div>
            )}
          </>
        )
      },
    },

    {
      field: 'temperatureHisotry',
      headerName: '온도 추이',
      renderCell: (params: any) => {
        return (
          <TemperatureHistoryChart className={'p-0'} checkList={params?.row?.temperatureList} />
        )
      },
      width: 600,
      align: 'center',
      headerAlign: 'center',
    },
  ]
}

export const customerPhotoColumns = (photoModalOpen: () => void, setPhotoData: any) => {
  return [
    {
      field: 'officeName',
      headerName: '사업소 명',
      renderCell: (params: any) => {
        return (
          <div className={'row text-center text-truncate gap-2'}>
            <span className='text-truncate'>{params.row.officeId}</span>
            <span className='text-truncate'>{params.row.officeName}</span>
            <span className='text-truncate '>{params.row.cooperName}</span>
          </div>
        )
      },
      width: 120,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },

    {
      field: 'customerInfo',
      headerName: '이름 / 주소',
      renderCell: (params: any) => {
        return (
          <div className={'row text-truncate'}>
            <span
              onClick={(e) => {}}
              className={'text-hover-danger cursor-pointer text-primary fw-bold text-truncate'}
            >
              {globalFormatWithHyphens(params.row.officeId, params.row.customerNumber)}
            </span>
            <span className={'text-truncate'}>{params.row.customerName}</span>
            <span className='text-truncate'>
              <strong style={{color: '#104f98'}}>도로명 </strong> : {params.row.addressRoad}{' '}
            </span>
            <span className='text-truncate'>
              <strong style={{color: '#f37005'}}>지번 </strong> : {params.row.addressNumber}{' '}
            </span>
          </div>
        )
      },
      width: 350,
      flex: 2,
      align: 'left',
      headerAlign: 'center',
    },
    {
      field: 'deviceInfo',
      headerName: '배터리 / 구경',
      renderCell: (params: any) => {
        const serialNumber = globalSerialNumberFormatWithHyphens(params.row.serialNumber)
        return (
          <div className={'row text-center'}>
            <span>{serialNumber}</span>
            <span className={`${params.row.batteryLevel < 30 ? 'text-danger' : 'text-dark'}`}>
              {params.row.batteryLevel} %
            </span>
            <span>{params.row.meterDiameter} mm</span>
          </div>
        )
      },
      width: 150,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },

    {
      field: 'efosStatus',
      headerName: '계량기',
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx
        return (
          <>
            <div className={'row w-100 h-100 text-center '} style={{alignContent: 'center'}}>
              <img
                src={
                  params?.row.efosStatus ? selectSuccessEfos(cooperIdx) : selectFailEFos(cooperIdx)
                }
                width={100}
                alt={'efos-check'}
              />
            </div>
          </>
        )
      },
      width: 120,

      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'deviceStatus',
      headerName: '단말기',
      renderCell: (params: any) => {
        const cooperIdx = params?.row.cooperIdx

        return (
          <>
            <div className={'row w-100 h-100 text-center '} style={{alignContent: 'center'}}>
              <img
                alt={'device-check'}
                src={
                  params.row.deviceStatus ? selectSuccessImg(cooperIdx) : selectFailImg(cooperIdx)
                }
                width={100}
              />
              {/* <span>{params.row.boardVersion === '22' ? 'v2.2' : 'v2.0'}</span> */}
            </div>
          </>
        )
      },
      width: 120,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'image',
      headerName: '이미지',
      width: 350,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const originalImage =
          params.row.filePath === null ? noImage : `${envImagePath}${params.row.filePath}`
        const rotate: string = params.row.rotate
        return (
          <>
            {params.row.deviceType !== 'analog' ? (
              <img className={'cursor-pointer'} src={defaultImage} alt={'default'} />
            ) : (
              <div className={'row'}>
                <img
                  onClick={(e: any) => {
                    e.stopPropagation()
                    setPhotoData(params.row)
                    photoModalOpen()
                  }}
                  className={'cursor-pointer'}
                  alt={'check-device'}
                  src={originalImage}
                  style={{
                    transform: params.row.filePath
                      ? (Number(rotate) > 90 && Number(rotate) < 270) ||
                        (Number(rotate) < -90 && Number(rotate) > -270)
                        ? `rotate(${rotate}deg)`
                        : `rotate(0deg)`
                      : `rotate(0deg)`,
                  }}
                />
              </div>
            )}
          </>
        )
      },
    },

    {
      field: 'checkInfo',
      headerName: '검침일',
      flex: 1,
      renderCell: (params: any) => {
        return (
          <div className={'row text-center'}>
            <div className={'d-flex justify-content-center'}>
              <span>
                {params.row.checkValue === '' ? (
                  <span className={'text-danger'}>인식불가</span>
                ) : (
                  params.row.checkValue
                )}
              </span>
              <span>
                {params.row.checkDecimalValue === '' || params.row.checkDecimalValue === null
                  ? ''
                  : '.' + params.row.checkDecimalValue?.split('.')[1]}
              </span>
            </div>

            <span>{dayjs(params.row.efosConnectAt).format('YYYY-MM-DD')}</span>
          </div>
        )
      },
      width: 160,
      align: 'center',
      headerAlign: 'center',
    },
  ]
}
